<template>
  <el-container class="box">
    <div class="header">
      <div class="text"><span>机构组织 / </span><span>医护团队</span></div>
      <div class="top-tabs">
        <div :class="activeName1 == 1 ? 'tabs-cliked' : ''" @click="handleTabClick(1)">
          <span>基本信息</span>
        </div>
        <div :class="activeName1 == 2 ? 'tabs-cliked' : ''" @click="handleTabClick(2)">
          <span>团队成员</span>
        </div>
        <div :class="activeName1 == 3 ? 'tabs-cliked' : ''" @click="handleTabClick(3)">
          <span>服务管理</span>
        </div>
        <div v-if="addedParamData.hasDoctor" :class="activeName1 == 4 ? 'tabs-cliked' : ''" @click="handleTabClick(4)">
          <span>问诊配置</span>
        </div>
        <div v-if="fiveFlag" :class="activeName1 == 5 ? 'tabs-cliked' : ''" @click="handleTabClick(5)">
          <span>资料配置</span>
        </div>
      </div>
    </div>
    <el-main class="content">
      <template v-if="activeName1 == 1">
        <div class="line-div">
          <span></span>
          <span>
            基本信息
          </span>
        </div>
        <template v-if="isEdit1">
          <el-form ref="addedParamData" @submit.native.prevent :model="addedParamData" label-width="120px"
            :rules="rules" size="small">
            <el-form-item label="团队头像：" :rules="[{required:true, message:'请上传团队头像',trigger:'change'}]" required
              prop="avatarImageUrl">
              <BaseUploadFile :fileSize="6" :isShowTip="false" :size="200" :height="180" :responseFn="handleResponse"
                :action="VUE_APP_BASE_URL" message="* 团队头像大小为200 * 180" :data="{ path: 'dsicm-doctor' }"
                v-model="addedParamData.avatarImageUrl">
              </BaseUploadFile>
            </el-form-item>
            <el-row style="margin: 8px 0;">
              <el-col :span="12">
                <el-form-item label="团队背景图：" :rules="[{required:true, message:'请上传团队背景图',trigger:'change'}]"
                  prop="backgroundImageUrl">
                  <BaseUploadFile :fileSize="6" :isShowTip="false" :size="60" :responseFn="handleBackgroundResponse"
                    :action="VUE_APP_BASE_URL" :data="{ path: 'dsicm-doctor' }"
                    v-model="addedParamData.backgroundImageUrl">
                  </BaseUploadFile>
                </el-form-item>
              </el-col>
              <el-col :span="12">

                <el-form-item :rules="[{required:true, message:'请上传消息推送图',trigger:'change'}]" label="消息推送图："
                  prop="messagePushImageUrl">
                  <BaseUploadFile :fileSize="6" :isShowTip="false" :size="60" :beforeUpLFn="beforeUpLFnHos"
                    :responseFn="handleMessageResponse" :action="VUE_APP_WECHATBASE_URL"
                    :data="{ path: 'dsicm-doctor', type: 'image', mediaId: '', hospitalId: addedParamData.hospitalId,}"
                    v-model="addedParamData.messagePushImageUrl">
                  </BaseUploadFile>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="团队名称: " prop="name">
                  <el-input v-model.trim="addedParamData.name" placeholder="请输入团队名称" maxlength="12">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="$store.state.userPlatForm === 'platForm'">
                <el-form-item label="线下机构: " prop="hospitalId">
                  <el-select v-model="addedParamData.hospitall" placeholder="请选择线下机构" filterable
                    @change="addHospitalChange" value-key=id :disabled="true">
                    <el-option v-for="item in hospitalOptions" :key="item.id" :label="item.name" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="团队科室: " prop="openDepartmentId">
                  <el-cascader v-model="addedParamData.openDepartmentId" ref="Mycascader"
                    @change="openDepartmentChange()" :options="openDepartmentList" :props="setKesDept"
                    placeholder="请选择团队科室" :disabled="true">
                  </el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="个案组: " prop="caseMgrGroupId">
                  <!-- 个案组 -->
                  <el-select @change="caseMgrGroupChange" v-model="addedParamData.caseMgrGroup"
                    placeholder="请输入关键词模糊搜索个案组" filterable value-key="id" :disabled="true">
                    <el-option v-for="item in treeListHos" :key="item.id" :label="item.reGroupName" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="团队擅长: " prop="professional">
              <el-input type="textarea" class="resizeNone" v-model="addedParamData.professional" placeholder="请输入团队擅长"
                maxlength="200">
              </el-input>
            </el-form-item>
            <el-form-item label="团队介绍: " prop="introduction">
              <el-input type="textarea" class="resizeNone" v-model.trim="addedParamData.introduction"
                placeholder="请输入团队介绍" maxlength="200">
              </el-input>
            </el-form-item>

            <el-form-item label="团队视频介绍: " prop="introduction">
              <div class="upload-vedio-wrapper">
                <div class="vedio"
                  v-if="addedParamData.introduceImageUrl && 
                  (addedParamData.introduceImageUrl.split('.')[1] == 'jpg' || addedParamData.introduceImageUrl.split('.')[1] == 'jpeg' || addedParamData.introduceImageUrl.split('.')[1] == 'png')">
                  <el-image style="width: 260px;" :src="ossBaseUrl + addedParamData.introduceImageUrl"
                    :preview-src-list="[ossBaseUrl + addedParamData.introduceImageUrl]"></el-image>
                  <!-- <div class="close-del">X</div> -->
                  <span @click="delTeamVedio">X</span>
                </div>
                <div v-else>
                  <div class="vedio" v-if="addedParamData.introduceImageUrl">
                    <show-video style="width: 260px;" :videoSrc="ossBaseUrl + addedParamData.introduceImageUrl">
                    </show-video>
                    <!-- <i class="el-icon-circle-close del-vedio-btn"></i> -->
                    <span @click="delTeamVedio">X</span>
                  </div>
                </div>
                <div class="vedio-upload-btn">
                  <!-- <el-button v-if="videoUploading" type="primary" size="small">正在上传中...</el-button> -->
                  <el-button v-if="videoUploading" type="primary" size="mini" :loading="true"
                    style="margin-top:6px">加载中</el-button>
                  <span v-if="!videoUploading && !addedParamData.introduceImageUrl">
                    <el-upload class="avatar-uploader" action="/api/dsicm-contact-platform/feign/file/upload"
                      :show-file-list="false" :data="{ path: 'dsicm-doctor' }" :on-success="handleAvatarSuccess"
                      :before-upload="beforeAvatarUpload">
                      <el-button type="primary" size="mini">上传视频/图片</el-button>
                    </el-upload>
                    <span class="team-video-intro">支持视频/图片上传，图片 jpg/png/jpeg、视频mp4/m4v</span>
                  </span>
                </div>
              </div>
            </el-form-item>

            <el-form-item label="团队案例配置：">
              <el-button type="primary" style="height:27px" :disabled="teamInstanceConfig.length >= 10" size="mini"
                @click="handleAddDoctorInstance">添加医生案例</el-button>

              <el-table id="tableInfo" :data="teamInstanceConfig" style="width: 100%">
                <el-table-column prop="useService" label="案例图片" align="center" width="140">
                  <template slot-scope="scope">
                    <img :src="scope.row.caseUrl" alt="" style="width:30px">
                  </template>
                </el-table-column>
                <el-table-column prop="caseText" label="案例文本" align="center">
                  <template slot-scope="scope">
                    <span v-html="scope.row.caseText"></span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="160">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" style="font-size:10px"
                      @click="editInstanceConfig(scope.row,scope.$index)">编辑</el-button>
                    <el-button type="text" size="mini" style="font-size:10px"
                      @click="delInstanceConfig(scope.row)">删除</el-button>
                    <!-- :disabled="scope.$index == 0 && searchForm.current == 1" -->
                    <el-button type="text" :disabled="scope.$index == 0" size="mini" style="font-size:10px"
                      @click="upInstanceConfig(scope.row)">上移</el-button>
                    <!--  :disabled="scope.row.disabled ? true : false" -->
                    <el-button type="text" :disabled="scope.$index == teamInstanceConfig.length - 1" size="mini"
                      style="font-size:10px" @click="downInstanceConfig(scope.row)">下移</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>

          </el-form>

        </template>
        <template v-else>
          <el-form ref="addedParamData" @submit.native.prevent :model="addedParamData" label-width="120px">
            <el-form-item label="团队头像: " size="mini">
              <el-image style="width: 200px; height: 180px;margin-right:10px" :src="addedParamData.avatarImageUrl"
                :z-index="2003">
                <div slot="error" class="image-slot">
                  <img src="@/assets/images/noImage.png">
                </div>
              </el-image>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="团队背景图: ">
                  <el-image style="width: 60px; height: 60px;margin-right:10px" :src="addedParamData.backgroundImageUrl"
                    :z-index="2003">
                    <div slot="error" class="image-slot">
                      <img src="@/assets/images/noImage.png">
                    </div>
                  </el-image>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="消息推送图: ">
                  <el-image style="width: 60px; height: 60px;margin-right:10px"
                    :src="addedParamData.messagePushImageUrl" :z-index="2003">
                    <div slot="error" class="image-slot">
                      <img src="@/assets/images/noImage.png">
                    </div>
                  </el-image>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="团队名称：" prop="titleId">
                  <span>{{addedParamData.name}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="$store.state.userPlatForm === 'platForm'">
                <el-form-item label="线下机构：" prop="doctorType">
                  <span>{{addedParamData.hospitalName ? addedParamData.hospitalName : '--'}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="团队科室：" prop="idCard">
                  <span>{{addedParamData.openDepartmentName ? addedParamData.openDepartmentName : '--'}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="个案组：" prop="hospitalId">
                  <span>{{addedParamData.caseMgrGroupName ? addedParamData.caseMgrGroupName : '--'}}</span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="团队擅长: " prop="professional">
              <span>{{addedParamData.professional ? addedParamData.professional : '--'}}</span>
            </el-form-item>
            <el-form-item label="团队介绍: " prop="introduction">
              <span>{{addedParamData.introduction?addedParamData.introduction:'--'}}</span>
            </el-form-item>

            <el-form-item label="团队视频介绍: " prop="introduction">
              <div class="upload-vedio-wrapper">
                <div class="vedio"
                  v-if="addedParamData.introduceImageUrl && (addedParamData.introduceImageUrl.split('.')[1] == 'jpg' || addedParamData.introduceImageUrl.split('.')[1] == 'jpeg' || addedParamData.introduceImageUrl.split('.')[1] == 'png')">
                  <el-image style="width: 260px;" :src="ossBaseUrl + addedParamData.introduceImageUrl"
                    :preview-src-list="[ossBaseUrl + addedParamData.introduceImageUrl]"></el-image>
                  <!-- <div class="close-del">X</div> -->
                  <!-- <span @click="delTeamVedio">X</span> -->
                </div>
                <div v-else>
                  <div class="vedio" v-if="addedParamData.introduceImageUrl">
                    <show-video style="width: 260px;" :videoSrc="ossBaseUrl + addedParamData.introduceImageUrl">
                    </show-video>
                    <!-- <i class="el-icon-circle-close del-vedio-btn"></i> -->
                    <!-- <span @click="delTeamVedio">X</span> -->
                  </div>
                </div>
              </div>
            </el-form-item>

            <el-form-item label="团队案例配置：">
              <el-table id="tableInfo" :data="teamInstanceConfig" style="width: 100%">
                <el-table-column prop="useService" label="案例图片" align="center">
                  <template slot-scope="scope">
                    <img :src="scope.row.caseUrl" alt="" style="width:30px">
                  </template>
                </el-table-column>
                <el-table-column prop="caseText" label="案例文本" align="center">
                  <template slot-scope="scope">
                    <span v-html="scope.row.caseText"></span>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                      <el-button type="text" size="mini" style="font-size:10px" @click="editInstanceConfig(scope.row,scope.$index)">编辑</el-button>
                      <el-button type="text" size="mini" style="font-size:10px" @click="delInstanceConfig(scope.$index)">删除</el-button>
                      <el-button type="text" size="mini" style="font-size:10px" @click="upInstanceConfig(scope.$index)">上移</el-button>
                      <el-button type="text" size="mini" style="font-size:10px" @click="downInstanceConfig(scope.$index)">下移</el-button>
                    </template>
                </el-table-column> -->
              </el-table>
            </el-form-item>
          </el-form>
        </template>
        <span class="dialog-footer" v-if="!isEdit1">

          <el-button size="small" type="primary" @click="detailEdit">编辑</el-button>
        </span>
        <span class="dialog-footer" v-if="isEdit1">
          <!-- <el-button size="small" @click="closeaddCare()">重置</el-button> -->
          <el-button size="small" type="primary" @click="submiAddCare5('addedParamData')">保存</el-button>
        </span>
      </template>
      <template v-if="activeName1 == 2">
        <div class="line-div" style="margin-bottom: 10px;">
          <span></span>
          <span>
            团队成员
          </span>
          <el-button type="primary" v-if="isEdit2" size="small" @click="addPeopel">新增成员</el-button>
        </div>
        <template>
          <el-table :header-cell-style="styleObj" :data="doctorTeamMemberList" style="width: 100%" :height="sysListIf ? '300px' : 'calc(100% - 100px)'">
            <el-table-column type="index" label="序号">
              <template slot-scope="scope">
                {{scope.$index * 1 + 1}}
              </template>
            </el-table-column>

            <el-table-column prop="doctorType" label="身份">
              <template slot-scope="scope">
                <span>{{(scope.row.doctorType == 1 && scope.row.leader) ? '领衔医生' : (scope.row.doctorType == 2&&scope.row.matron) ? '护士长' :  '成员'}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="doctorType" label="医护类型">
              <template slot-scope="scope">
                <span>{{scope.row.doctorType == 1 ? '医生' : scope.row.doctorType == 2 ? '护士' :  scope.row.doctorType == 4 ? '药师' : '医辅'}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名">
              <template slot-scope="scope">
                <span>{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="titleName" label="职称">
              <template slot-scope="scope">
                <span>{{scope.row.titleName}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="hospitalName" show-overflow-tooltip label="线下机构">
              <template slot-scope="scope">
                <div v-if="scope.row.doctorType == 6">
                  <span v-if="scope.row.hospitalList">{{hospitalNameFun(scope.row.hospitalList,1)}}</span>
                  <span v-else>--</span>
                </div>
                <div v-else>
                  <span v-if="scope.row.hospitalName">{{scope.row.hospitalName}}</span>
                  <span v-else>--</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="departmentName" label="线下科室" show-overflow-tooltip>
              <template slot-scope="scope">
                <div v-if="scope.row.doctorType == 6">
                  <span v-if="scope.row.hospitalList">{{hospitalNameFun(scope.row.hospitalList,2)}}</span>
                  <span v-else>--</span>
                </div>
                <div v-else>
                  <span v-if="scope.row.departmentName">{{scope.row.departmentName}}</span>
                  <span v-else>--</span>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="hospitalName" label="线下机构" width="130px">
                    <template slot-scope="scope">
                      <span>{{scope.row.hospitalName}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="departmentName" label="线下科室">
                    <template slot-scope="scope">
                      <span>{{scope.row.departmentName}}</span>
                    </template>
                  </el-table-column> -->
            <el-table-column label="操作" width="170" v-show="isEdit2">
              <template slot-scope="scope">
                <el-button type="text" size="mini"
                  :disabled="(scope.row.doctorType == 1 && scope.row.leader)||(scope.row.doctorType == 2 && scope.row.matron)"
                  @click="TeamAdministration2(scope, 'remove')">移除</el-button>
                <el-button type="text" size="mini" v-if="scope.row.doctorType==2"
                  @click="TeamAdministration2(scope, 'first')">{{scope.row.matron ? '护士长' : '设为护士长'}}</el-button>
                <el-button type="text" size="mini" v-if="scope.row.doctorType==1&&!scope.row.leader"
                  @click="TeamAdministration2(scope, 'mdt')">{{scope.row.mdt ? 'MDT' : '执行医生'}}</el-button>
              </template>
            </el-table-column>
          </el-table>

        </template>
        <div style="margin-top: 40px;" v-if="sysListIf">
          <div class="line-div">
            <span></span>
            <span>
              搜索成员
            </span>
          </div>
          <el-form :inline="true" :model="formInline1" class="demo-form-inline" size="small">
            <el-form-item v-if="$store.state.userPlatForm === 'platForm'">
              <selectHospital :hospital="formInline1.hospital" placeholder="请选择" @getChooseHospitalId="getChooseHospitalId" ref="selectHospitalId"></selectHospital>
            </el-form-item>
            <el-form-item>
              <el-input style="width: 200px;" v-model="formInline1.keyword" placeholder="请输入医护姓名/线下科室"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="resetHandel1">重置</el-button>
              <el-button type="primary" @click="formInlineSubmit">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="list-two">
            <el-table :header-cell-style="styleObj" id="tableInfo" :data="tableData1" style="width: 100%">
              <el-table-column type="index" label="序号">
                <template slot-scope="scope">
                  {{scope.$index * 1 + 1}}
                </template>
              </el-table-column>
              <el-table-column prop="doctorTypeName" label="医护类型" align="center">
                <template slot-scope="scope">
                  {{scope.row.doctorTypeName}}
                </template>
              </el-table-column>
              <el-table-column prop="name" label="姓名" align="center">
                <template slot-scope="scope">
                  {{scope.row.name}}
                </template>
              </el-table-column>
              <el-table-column prop="titleName" label="职称" align="center">
                <template slot-scope="scope">
                  {{scope.row.titleName}}
                </template>
              </el-table-column>
              <!-- <el-table-column label="线下机构" align="center" prop="hospitalName">
                <template slot-scope="scope">
                  {{scope.row.hospitalName}}
                </template>
              </el-table-column>
              <el-table-column prop="departmentName" label="线下科室" align="center">
                <template slot-scope="scope">
                  {{scope.row.departmentName}}
                </template>
              </el-table-column> -->
              <el-table-column align="center" prop="hospitalName" show-overflow-tooltip label="线下机构">
                <template slot-scope="scope">
                  <div v-if="scope.row.doctorType == 6">
                    <span v-if="scope.row.hospitalList">{{hospitalNameFun(scope.row.hospitalList,1)}}</span>
                    <span v-else>--</span>
                  </div>
                  <div v-else>
                    <span v-if="scope.row.hospitalName">{{scope.row.hospitalName}}</span>
                    <span v-else>--</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="departmentName" label="线下科室" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div v-if="scope.row.doctorType == 6">
                    <span v-if="scope.row.hospitalList">{{hospitalNameFun(scope.row.hospitalList,2)}}</span>
                    <span v-else>--</span>
                  </div>
                  <div v-else>
                    <span v-if="scope.row.departmentName">{{scope.row.departmentName}}</span>
                    <span v-else>--</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="操作" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button @click="choisePerson2(scope.row, scope.$index)" type="text" size="small">
                    添加
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination class="pagenation" background @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page.sync="formInline1.current" :page-size="formInline1.size"
            layout="total, sizes, prev, pager, next, jumper" :total="formInline1.total">
          </el-pagination>
        </div>
        <span class="dialog-footer" v-if="!isEdit2">

          <el-button size="small" type="primary" @click="isEdit2 = true">编辑</el-button>
        </span>
      </template>
      <template v-if="activeName1 == 3" class="info-upload">
        <div class="line-div" style="justify-content:space-between; margin-bottom: 0;">
          <!-- <span></span>
          <span>
            服务管理

          </span> -->
          <el-tabs v-model="activeServeTab" @tab-click="handleServeTabClick">
            <el-tab-pane label="医生服务管理" name="first">
            </el-tab-pane>
            <el-tab-pane label="权益服务管理" name="second">
            </el-tab-pane>
          </el-tabs>
          <el-button type="primary" v-if="isEdit3" size="small" @click="serviceOpen" class="add-serve-btn">新增服务
          </el-button>
        </div>

        <div v-show="activeServeTab == 'first'">
          <template>
            <el-table :header-cell-style="styleObj" :data="teamServiceList" style="width: 100%" max-height="580px">
              <el-table-column type="index" label="序号">
                <template slot-scope="scope">
                  {{scope.$index * 1 + 1}}
                </template>
              </el-table-column>
              <el-table-column prop="name" label="医生链名称">
                <template slot-scope="scope">
                  {{scope.row.name}}
                </template>
              </el-table-column>
              <el-table-column prop="diseaseType" label="主适配病种"></el-table-column>
              <el-table-column label="服务周期">
                <template slot-scope="scope">
                  {{scope.row.period + '' + scope.row.periodType}}
                </template>
              </el-table-column>
              <el-table-column prop="edit" label="服务价格现价（元）">
                <template slot-scope="scope">
                  <span v-if="!scope.row.edit">{{scope.row.price}}</span>
                  <el-input type="text" v-if="scope.row.edit" clearable v-model="scope.row.price"></el-input>
                  <!-- <el-input-number style="width: 130px;" v-if="scope.row.edit" v-model="scope.row.price"
                    :controls="false"></el-input-number> -->
                </template>
              </el-table-column>
              <el-table-column prop="edit" label="原价（元）">
                <template slot-scope="scope">
                  <span v-if="!scope.row.edit">{{scope.row.originalPrice}}</span>
                  <el-input type="text" v-if="scope.row.edit" clearable v-model="scope.row.originalPrice"></el-input>
                  <!-- <el-input-number style="width: 130px;" v-if="scope.row.edit" v-model="scope.row.originalPrice"
                    :controls="false"></el-input-number> -->
                </template>
              </el-table-column>
              <!-- 医生服务为付费类型时展示前端展示 -->
              <el-table-column prop="patientShow" label="前端展示">
                <template slot-scope="scope">
                  <span v-if="!scope.row.edit"
                    :style="`color:#fff;padding:7px;border-radius:2px;background:${scope.row.patientShow === true ? '#0CB79F' : scope.row.patientShow === false ? '#FCB023' : ''}`">{{ scope.row.patientShow === true ? '是' : scope.row.patientShow === false ? '否' : '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="patientShow" label="服务版本类型">
                <template slot-scope="scope">
                  <span v-if="!scope.row.edit">{{ translateServiceVersionType(scope.row.serviceLevel) }}</span>
                  <el-select v-model="scope.row.serviceLevel" placeholder="请选择" v-else>
                    <el-option v-for="item in serviceVersionTypeList" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="synergyRightsTotalPrice" label="协同权益总额">
                <template slot-scope="scope">
                  <span v-if="!scope.row.edit">{{ scope.row.synergyRightsTotalPrice}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="180" v-if="isEdit3">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="TeamAdministration3(scope, 'remove')">移除</el-button>
                  <el-button type="text" size="mini" @click="TeamAdministration3(scope, 'first')">
                    {{scope.row.edit ? '保存' : '编辑'}}</el-button>
                  <!-- 仅可设定1个服务为置顶 -->
                  <el-button type="text" size="mini" @click="TeamAdministration3(scope, 'second')">
                    {{scope.row.recommend ? '取消推荐' : '设为推荐'}}</el-button>
                  <!-- 医生服务为付费类型时展示前端展示 -->
                  <el-button type="text" size="mini" @click="showFront(scope.row)">
                    {{scope.row.patientShow ? '不展示' : '展示'}}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>

          <!-- </template> -->
          <div v-show="ServiceListIf" style="margin-top: 40px;">
            <div class="line-div">
              <span></span>
              <span>
                搜索服务
              </span>
            </div>
            <el-form :inline="true" :model="formInline2" class="demo-form-inline" @submit.native.prevent>
              <el-row>
                <el-col :span="12">
                  <el-input v-model="formInline2.name" placeholder="请输入医生链名称" @keyup.enter.native="formInlineSubmit1">
                  </el-input>
                </el-col>
                <el-col :span="8" style="margin-left: 10px;">
                  <el-form-item>
                    <el-button size="small" @click="resetHandel2">重置</el-button>
                    <el-button size="small" type="primary" @click="formInlineSubmit1">搜索</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div class="list-two">
              <el-table :header-cell-style="styleObj" id="tableInfo" :data="tableData2" style="width: 100%">
                <el-table-column type="index" label="序号">
                  <template slot-scope="scope">
                    {{scope.$index * 1 + 1}}
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="医生链名称" align="center">
                  <template slot-scope="scope">
                    {{scope.row.name}}
                  </template>
                </el-table-column>
                <el-table-column label="服务周期" align="center">
                  <template slot-scope="scope">
                    {{scope.row.period+scope.row.periodType}}

                  </template>
                </el-table-column>
                <el-table-column prop="diseaseType" label="适配病种" align="center"></el-table-column>
                <el-table-column prop="synergyRightsTotalPrice" label="协同权益总额" align="center"></el-table-column>
                <el-table-column v-if="isEdit3" label="操作" align="center" fixed="right">
                  <template slot-scope="scope">
                    <el-button @click="choisePerson3(scope.row, scope.$index)" type="text" size="small">
                      添加
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-pagination class="pagenation" background @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1" :current-page.sync="formInline2.current"
              :page-size="formInline2.size" layout="total, sizes, prev, pager, next, jumper" :total="formInline2.total">
            </el-pagination>
          </div>

        </div>

        <div v-show="activeServeTab == 'second'">
          <template>
            <el-table :header-cell-style="styleObj" :data="teamServiceList" style="width: 100%" max-height="500px">
              <el-table-column type="index" label="序号">
                <template slot-scope="scope">
                  {{scope.$index * 1 + 1}}
                </template>
              </el-table-column>
              <el-table-column prop="name" label="医生链权益链名称">
                <template slot-scope="scope">
                  {{scope.row.name}}
                </template>
              </el-table-column>
              <el-table-column prop="diseaseType" label="主适配病种"></el-table-column>
              <el-table-column prop="commonStatus" label="公共领取">
                <template slot-scope="scope">
                  {{scope.row.commonStatus ? '是' : '否'}}
                </template>
              </el-table-column>
              <el-table-column label="服务周期">
                <template slot-scope="scope">
                  {{scope.row.period + '' + scope.row.periodType}}
                </template>
              </el-table-column>
              <el-table-column prop="edit" label="服务价格现价（元）">
                <template slot-scope="scope">
                  <span v-if="!scope.row.edit">{{scope.row.price}}</span>
                  <el-input type="text" v-if="scope.row.edit" clearable v-model="scope.row.price"></el-input>
                  <!-- <el-input-number style="width: 130px;" v-if="scope.row.edit" v-model="scope.row.price"
                    :controls="false"></el-input-number> -->
                </template>
              </el-table-column>
              <el-table-column prop="edit" label="原价（元）">
                <template slot-scope="scope">
                  <span v-if="!scope.row.edit">{{scope.row.originalPrice}}</span>
                  <el-input type="text" v-if="scope.row.edit" clearable v-model="scope.row.originalPrice"></el-input>
                  <!-- <el-input-number style="width: 130px;" v-if="scope.row.edit" v-model="scope.row.originalPrice"
                    :controls="false"></el-input-number> -->
                </template>
              </el-table-column>
              <el-table-column prop="synergyRightsTotalPrice" label="协同权益总额">
                <template slot-scope="scope">
                  <span v-if="!scope.row.edit">{{scope.row.synergyRightsTotalPrice}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="180" v-if="isEdit3">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="TeamAdministration3(scope, 'remove')">移除</el-button>
                  <el-button type="text" size="mini" @click="TeamAdministration3(scope, 'first')">
                    {{scope.row.edit ? '保存' : '编辑'}}</el-button>
                  <!-- <el-button type="text" size="mini" @click="TeamAdministration3(scope, 'second')">
                    {{scope.row.recommend ? '取消推荐' : '设为推荐'}}</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </template>

          <!-- </template> -->
          <div v-show="ServiceListIf" style="margin-top: 40px;">
            <div class="line-div">
              <span></span>
              <span>
                搜索服务
              </span>

            </div>
            <el-form :inline="true" :model="formInline2" class="demo-form-inline" @submit.native.prevent>
              <el-row>
                <el-col :span="12">
                  <el-input v-model="formInline2.name" placeholder="请输入医生链权益链名称"
                    @keyup.enter.native="formInlineSubmit1"></el-input>
                </el-col>
                <el-col :span="8" style="margin-left: 10px;">
                  <el-form-item>
                    <el-button size="small" @click="resetHandel2">重置</el-button>
                    <el-button size="small" type="primary" @click="formInlineSubmit1">搜索</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div class="list-two">
              <el-table :header-cell-style="styleObj" id="tableInfo" :data="tableData2" style="width: 100%">
                <el-table-column type="index" label="序号">
                  <template slot-scope="scope">
                    {{scope.$index * 1 + 1}}
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="医生链权益链名称" align="center">
                  <template slot-scope="scope">
                    {{scope.row.name}}
                  </template>
                </el-table-column>
                <el-table-column prop="diseaseType" label="主适配病种"></el-table-column>
                <el-table-column prop="commonStatus" label="公共领取">
                  <template slot-scope="scope">
                    {{scope.row.commonStatus ? '是' : '否'}}
                  </template>
                </el-table-column>
                <el-table-column label="服务周期" align="center">
                  <template slot-scope="scope">
                    {{scope.row.period+scope.row.periodType}}

                  </template>
                </el-table-column>
                <el-table-column prop="subDiseaseTypes" label="适配病种" align="center"></el-table-column>
                <el-table-column prop="synergyRightsTotalPrice" label="协同权益总额" align="center"></el-table-column>
                <el-table-column v-if="isEdit3" label="操作" align="center" fixed="right">
                  <template slot-scope="scope">
                    <el-button @click="choisePerson3(scope.row, scope.$index)" type="text" size="small">
                      添加
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-pagination class="pagenation" background @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1" :current-page.sync="formInline2.current"
              :page-size="formInline2.size" layout="total, sizes, prev, pager, next, jumper" :total="formInline2.total">
            </el-pagination>
          </div>

        </div>
        <span class="dialog-footer" v-if="!isEdit3">

          <el-button size="small" type="primary" @click="isEdit3=true">编辑</el-button>
        </span>
      </template>
      <div v-if="activeName1 == 4">
        <div class="line-div">
          <span></span>
          <span>
            问诊配置
          </span>
        </div>
        <template v-if="isEdit4">
          <el-form ref="cnForm" @submit.native.prevent :model="information2" label-width="140px" :rules="rules1">
            <el-form-item label="开启图文问诊: " prop="disabled">
              <el-radio-group v-model="information2.disabled" @change="disabledChanged">
                <el-radio :label="false">是</el-radio>
                <el-radio :label="true">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-row>
              <el-col :span="14">
                <el-form-item v-if="!information2.disabled" label="咨询费: " prop="consultFee">
                  <el-input type="text" v-model.trim="information2.consultFee" placeholder="请输入咨询费"
                    @change="inputCusltFee">
                    <template slot="append">元</template>
                  </el-input>
                  <!-- <el-input-number placeholder="请输入咨询费" v-model="information2.consultFee"
                          :controls="false">
                          <template slot="append">元</template></el-input-number> -->
                </el-form-item>

              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14">
                <el-form-item v-if="!information2.disabled" label="服务时长: " prop="serviceTime">
                  <el-input type="text" v-model.trim="information2.serviceTime" placeholder="请输入服务时长">
                    <template slot="append">小时</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col>
                <el-form-item label="咨询简介: " prop="describe" v-if="!information2.disabled">
                  <el-input resize="none" maxlength="30" type="textarea" show-word-limit
                    placeholder="建议填写图文咨询的简短介绍.(例如：医生接诊后24小时内无限次交流)" v-model.trim="information2.describe">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col>
                <el-form-item label="开启协同: " prop="synergyDisabled">
                  <el-radio-group v-model="information2.synergyDisabled">
                    <el-radio :label="false">是</el-radio>
                    <el-radio :label="true">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14">
                <el-form-item v-if="!information2.synergyDisabled" label="图文咨询费: " prop="synergyTextConsultFee">
                  <el-input type="text" v-model.trim="information2.synergyTextConsultFee" placeholder="请输入咨询费">
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14">
                <el-form-item v-if="!information2.synergyDisabled" label="视频咨询费: " prop="synergyVideoConsultFee">
                  <el-input type="text" v-model.trim="information2.synergyVideoConsultFee" placeholder="请输入咨询费">
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14">
                <el-form-item v-if="!information2.synergyDisabled" label="服务时长: ">
                  <el-input type="text" v-model.trim="information2.synergyServiceTime" placeholder="请输入服务时长"
                    onkeyup="value = value.replace(/[^\d]/g,'')" maxlength="2">
                    <template slot="append">小时</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item v-if="!information2.synergyDisabled" label="咨询简介: " prop="synergyDescribe">
                  <el-input resize="none" maxlength="30" show-word-limit type="textarea"
                    placeholder="建议填写图文咨询的简短介绍.(例如：医生接诊后24小时内无限次交流)" v-model.trim="information2.synergyDescribe">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <span class="dialog-footer">
              <el-button class="dialog-btn" size="small" type="primary" @click="submiAddCare6('cnForm')">保存</el-button>
            </span>

          </el-form>
        </template>
        <template v-else>
          <el-form @submit.native.prevent :model="information2" label-width="100px" :rules="rules1">
            <p v-if="information2.disabled==0"
              style="font-size:14px;margin-bottom:35px;font-weight:bolder;color: #1A7BFC;width:100px;text-align:right">
              图文咨询</p>

            <el-form-item label="咨询费: " prop="consultFee" v-if="information2.disabled==0">

              <span>{{information2.consultFee}}</span>
            </el-form-item>

            <el-form-item v-if="information2.disabled==0" label="服务时长: " prop="serviceTime">

              <span>{{information2.serviceTime}}</span>
            </el-form-item>

            <el-form-item v-if="information2.disabled==0" label="咨询简介: " prop="describe">
              <span>{{information2.describe}}</span>
            </el-form-item>
            <el-form-item v-if="!information2.synergyDisabled" label="开启协同: " prop="consultFee">
              <span style="font-size:14px;font-weight:bolder;color: #1A7BFC;width:100px;text-align:right">
                {{!information2.synergyDisabled?'是':'否'}}
              </span>
            </el-form-item>

            <el-form-item v-if="!information2.synergyDisabled" label="图文咨询费: " prop="synergyTextConsultFee">
              <span>{{ information2.synergyTextConsultFee }}</span>
            </el-form-item>

            <el-form-item v-if="!information2.synergyDisabled" label="视频咨询费: " prop="synergyVideoConsultFee">
              <span>{{ information2.synergyVideoConsultFee }}</span>
            </el-form-item>

            <el-form-item v-if="!information2.synergyDisabled" label="服务时长: ">
              <span>{{ information2.synergyServiceTime }}</span>
            </el-form-item>

            <el-form-item v-if="!information2.synergyDisabled" label="咨询简介: " prop="synergyDescribe">
              <span>{{ information2.synergyDescribe }}</span>
            </el-form-item>
          </el-form>
          <div v-if='information2.disabled != 0 && information2.synergyDisabled' class="no-div">
            <img src="@/assets/images/nodata.png" alt="">
            <p>暂未开通问诊</p>
          </div>
          <span class="dialog-footer" v-if="!isEdit4">
            <el-button class="dialog-btn" size="small" type="primary" @click="isEdit4 = true">去编辑</el-button>
          </span>

        </template>
      </div>
      <div v-if="activeName1 == 5">
        <el-form ref="paramData" :model="paramData" label-width="120px" :rules="paramRules">
          <div>
            <!--  style="height: 38px; width: 90%; overflow:hidden;" -->
            <el-form-item label="已配置病种: ">
              <div class="tabs-box">
                <span v-for="(item,index) in tagDiseaseList" :key="index" class="sub-tabs-list"
                  v-show="index < foldIndex">
                  <span :class="`searchTag${diseaseActive === item.label ? ' active' : ''}`" @click="tagDetail(item)"
                    v-if="item.label">
                    {{item.label}}
                  </span>
                </span>
                <!-- 查看全部按钮 -->
                <span class="all-detail-icon" ref="fold" @click="detailAllDisease"
                  v-show="tagDiseaseList && tagDiseaseList.length > foldIndex">查看全部<i
                    class="el-icon-arrow-down"></i></span>
                <span class="all-detail-icon" ref="fold" @click="retractClick"
                  v-show="tagDiseaseList && tagDiseaseList.length === foldIndex">收起<i
                    class="el-icon-arrow-up"></i></span>
                <span class="no-disease" v-show="!tagDiseaseList || !tagDiseaseList.length">暂无病种配置</span>
              </div>
            </el-form-item>
          </div>
          <div class="diease-btn-select">
            <el-form-item>
              <!-- 病种选择框展示&病种已被选择时按钮被禁用addDiseaseVisible -->
              <el-button type="primary" @click="addDiseaseConfig" :disabled="bigStatus" size="small"
                style="margin-right: 20px">新增病种配置</el-button>
              <div v-if="addDiseaseVisible">
                <el-form-item label="病种: " prop="diseaseId" label-width="55px">
                  <el-select v-model="paramData.diseaseId" placeholder="请选择病种" filterable @change="hospitalChangeNew"
                    value-key="id" size="small" style="width:300px">
                    <el-option v-for="item in diseaseTypeList" :key="item.id" :label="item.suborderName"
                      :value="item.id" :disabled="isDisabledDisease(item.suborderName)">
                    </el-option>
                  </el-select>
                  <el-button type="primary" @click="addDiseaseSure" size="small"
                    style="margin-left: 10px">确定</el-button>
                </el-form-item>
              </div>
            </el-form-item>
          </div>
          <div v-if="tagDiseaseList.length > 0">
            <div v-if="diseaseId">
              <el-form-item label="重点字段设置：">
                <KeyField ref="child" :oldList="dataList" :allOldList="dataListDelete" :diseaseId="diseaseId"
                  :openDepartmentId="openDepartmentIdNew" :openDepartmentParentId="openDepartmentParentIdNew"
                  :hospitalId="hospitalNewId" :statusType="statusType" :bigStatus="bigStatus" :teamId="teamIdNew"
                  @confimClick="confimClick" @editFlagStatusClick="editFlagStatusClick"
                  @saveChildClick="saveChildClick"></KeyField>
              </el-form-item>
            </div>
          </div>
          <div class="btn-box" v-if="diseaseId">
            <el-button type="primary" v-preventReClick v-if="bigStatus" @click="saveClick('paramData')">保存</el-button>
            <el-button type="primary" v-else @click="editClick">编辑</el-button>
          </div>
        </el-form>
      </div>
    </el-main>
    <!-- 添加医生案例 -->
    <AddDoctorInstance :showDoctorInstance.sync="showDoctorInstance" v-if="showDoctorInstance" :teamId="teamIdNew"
      :selectInstanceRow="selectInstanceRow" @receiveInstance="receiveInstance"></AddDoctorInstance>
  </el-container>
</template>

<script>
import local from "@/utils/local.js";
import KeyField from "./components/KeyField.vue";
import ShowVideo from "@/views/SystemSettings/component/video.vue";
import {
  doctorTeam,
  openeDpartment,
  setAsLeader,
  setAsMatron, //设置护士长
  treeList,
  focusFieldConfig,
  moveUpInstance,
  moveDownInstance,
  getInstanceData,
  delInstanceData,
} from "@/api/doctorTeam.js";
import { plateFormOn } from "@/api/acc.js";
import {
  getPlatformList,
  getPlatformDepartmentList,
  getHospitalDepartmentList,
  doctorTeamCreate,
  doctorSearch,
  doctorUpdate,
  doctorSearch1,
  addMemberSearch,
  AdddoctorMember,
  doctorMemberDelete,
  AddService,
  updateByOriginalPrice,
  getServiceByTeamId,
  setAsRecommend,
  doctorServiceDelete,
  setAsMdt,
  setAsExecutive,
  // setAsMatron,
  // setAsLeader
  updatePatientShow,
} from "./api";
import { commonQuery, saveConfig, updateConfig } from "./api/index";
import {
  findDiseaseTypeByother,
  findDiseaseType,
} from "./departmentHomePage/api/index";
import {
  inquiry_config_detailByRefId,
  inquiry_config,
} from "./api/medicalinfo";
import { imgBaseURL } from "@/utils/common.js";
import RecognitionRule from "@/components/RecognitionRule/index.vue";
export default {
  components: {
    KeyField,
    RecognitionRule,
    AddDoctorInstance: () => import("./components/AddDoctorInstance.vue"),
    ShowVideo,
  },
  props: {},
  data() {
    // 手机号验证
    var validatorConsultFee = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请按要求输入咨询费"));
      } else if (!/^\d+(\.\d+)?$/.test(value)) {
        callback(new Error("请按要求输入咨询费"));
      } else {
        callback();
      }
    };
    // 身份证验证
    var validatorServiceTime = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请按要求输入服务时长"));
      } else if (!/^\d+$|^\d*\.\d+$/g.test(value)) {
        callback(new Error("请按要求输入服务时长"));
      } else {
        callback();
      }
    };
    return {
      selectInstanceRow: {},
      videoUploading: false,
      // teamVideoUrl: '',
      ossBaseUrl: process.env.VUE_APP_OSS_URL, //预览图片基础路径
      showDoctorInstance: false,
      teamInstanceConfig: [],

      recognitionRule: {
        visible: true,
        title: "识别规则配置",
        id: "",
      },
      activeServeTab: "first",
      userId: "",
      doctorTeamMemberList: [],
      teamServiceList: [],
      tableData1: [],
      formInline1: {
        size: 10,
        current: 1,
        keyword: "",
        total: 0,
      },
      tableData2: [],
      formInline2: {
        size: 10,
        current: 1,
        name: "",
        total: 0,
      },
      styleObj: {
        background: "#FAFAFA",
        fontWeight: "bold",
        color: "#333333",
        fontSize: "14px",
      },
      ServiceListIf: false,
      sysListIf: false,
      addedParamData: {
        hasDoctor: false,
        name: "", //团队名称
        platformName: "",
        platformId: "", //归属平台
        departmentName: "",
        departmentId: "", //归属科室
        avatarImageUrl: "", //团体头像
        backgroundImageUrl: "", //背景图
        messagePushImageUrl: "", //消息推送图
        introduction: "", //团队介绍
        professional: "", //团队擅长
        caseMgrGroupName: "",
        caseMgrGroupId: "", //个案组ID,实际关联用户部门ID
        caseMgrGroup: {},
        id: "", //修改团队id
        mediaId: "", //微信推送素材ID
        hospitalId: "",
        hospitalName: "",
        openDepartmentName: "",
        openDepartmentId: "",
        introduceImageUrl: "",
      },
      VUE_APP_WECHATBASE_URL: "",
      treeListHos: [],
      openDepartmentList: [],
      diseaseTypeList: [], // 线下机构列表
      activeName1: 1,
      crolBtn: false,
      isEdit1: false,
      isEdit2: false,
      isEdit3: false,
      isEdit4: false,
      loadingNew: false,
      userPlatForm: local.get("userPlatForm"), //平台：platForm 机构：organization local.get('userPlatForm')
      SetKesDept: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false,
      }, //设置联级选择器绑定的值
      setKesDept: {
        value: "id",
        label: "name",
        children: "children",
        disabled: "value",
        emitPath: false,
      },
      information1: {
        realName: "", //姓名
        mobile: "", //手机号码
        idCard: "", //证件 号码
        // gender: '', //性别 1男2女0未知
        // birthday: '', //出生日期
        avatar: "", //医生照片
        photoUrlCopy: "", //用来展示图片
        note: "", //介绍
        departmentId: "", //科室ID
        departmentName: "",
        doctorType: "", //医护类型1.医生,2.护士,3.医技,4.药师6医辅
        hospitalId: "", //医院ID
        hospitalName: "",
        professional: "", //专业擅长
        titleId: "", //职称ID
        titleName: "",
        serviceScopeKm: "", //上门服务km
        provideNursingService: true,
      },
      doctorCertificateSubmitDTO: {
        idCard: {
          back: "",
          front: "",
          watermarkBack: "",
          watermarkFront: "",
        },
        other: {
          watermarkFiles: "",
          files: [],
        },
        practice: {
          watermarkFiles: "",
          files: [],
          number: "",
          obtainDate: "",
        },
        qualification: {
          watermarkFiles: "",
          files: [],
          obtainDate: "",
          number: "",
        },
        title: {
          watermarkFiles: "",
          files: [],
          obtainDate: "",
          number: "",
        },
        nameBadge: {
          watermarkFiles: "",
          files: [],
          obtainDate: "",
          number: "",
        },
      },
      doctorTeam: {
        type: "0",
        id: "",
        doctorTeamName: "",
        name: "",
        departmentId: "",
        departmentName: "",
        platformId: "",
        platformName: "",
        caseMgrGroupId: "",
        caseMgrGroupName: "",
      },
      newSelectTteam: "",
      upavater: "", //需要上传的图片路径
      VUE_APP_BASE_URL: "",
      VUE_APP_BASE_URL1: "",
      isMdt: false,
      doctorTitleList: [],
      joinedTeamList: [],
      doctorTeamList: [], //其他团队
      platformOptions: [], //归属平台
      departmentList: [], //归属科室
      departmentList1: [], //归属科室
      caseMgrGroupList: [], //个案组列表
      hospitalList: [],
      rules: {
        name: [
          {
            required: true,
            message: "请输入团队名称",
            trigger: "blur",
          },
          {
            min: 3,
            max: 25,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        hospitalId: [
          {
            required: true,
            message: "请选择线下机构",
            trigger: "change",
          },
        ],
        // 团队科室
        openDepartmentId: [
          {
            required: true,
            message: "请选择团队科室",
            trigger: "change",
          },
        ],
        departmentId: [
          {
            required: true,
            message: "请选择归属科室",
            trigger: "change",
          },
        ],
        caseMgrGroupId: [
          {
            required: true,
            message: "请选择个案组",
            trigger: "change",
          },
        ],
      },
      paramRules: {
        diseaseId: [
          {
            required: true,
            message: "请选择病种",
            trigger: "change",
          },
        ],
      },
      flagId: "",
      information2: {
        disabled: true,
        consultFee: "",
        serviceTime: "",
        describe: "",
        id: "",
        freeClinicsDisabled: true,
        synergyDisabled: true,
        synergyTextConsultFee: "",
        synergyVideoConsultFee: "",
        synergyServiceTime: "",
        synergyDescribe: "",
      },
      rules1: {
        disabled: [
          {
            required: true,
            message: "请选择是否开启",
            trigger: "blur",
          },
        ],
        consultFee: [
          {
            required: true,
            // validate:validatorConsultFee,
            trigger: "blur",
            pattern: /^\d+(\.\d+)?$/,

            message: "请按要求输入咨询费",
          },
        ],
        serviceTime: [
          {
            required: true,
            pattern: /^[1-9]\d*$/,
            // validate:validatorServiceTime,
            message: "请按要求输入服务时长",
            trigger: "blur",
          },
        ],
        synergyDisabled: [
          {
            required: true,
            message: "请选择协同",
            trigger: "change",
          },
        ],
        synergyTextConsultFee: [
          {
            required: true,
            // validate:validatorConsultFee,
            trigger: "blur",
            pattern: /^\d+(\.\d+)?$/,
            message: "请按要求输入图文咨询费",
          },
        ],
        synergyVideoConsultFee: [
          {
            required: true,
            // validate:validatorConsultFee,
            trigger: "blur",
            pattern: /^\d+(\.\d+)?$/,
            message: "请按要求输入视频咨询费",
          },
        ],
        synergyServiceTime: [
          {
            required: true,
            pattern: /^[1-9]\d*$/,
            // validate:validatorServiceTime,
            message: "请按要求输入服务时长",
            trigger: "blur",
          },
        ],
      },
      approved: false,
      paramData: { diseaseId: null, focusFieldConfigDetailList: [] },
      hospitalOptions: [],
      hospitalNewId: "",
      statusType: "team",
      openDepartmentIdNew: "",
      openDepartmentParentIdNew: "",
      dataList: [],
      teamIdNew: "",
      editFlagStatus: false,
      newId: null, //用来更新的id
      dataListDelete: [],
      fiveFlag: false,
      bigStatus: false,
      addDiseaseVisible: false, // 是否展示病种选择框
      diseaseActive: "胆管癌",
      tagDiseaseList: [], // 已配置病种
      foldIndex: 100,
      diseaseId: null,
      serviceVersionTypeList: [
        {
          label: "标准版",
          value: "normal",
        },
        {
          label: "升级版",
          value: "premium",
        },
        {
          label: "专享版",
          value: "exclusive",
        },
        {
          label: "尊享版",
          value: "exalted",
        },
      ],
    };
  },
  watch: {
    "addedParamData.hospitalId": {
      handler: function (newVal, oldVal) {
        // alert('898998')
        this.getTreeListHos(newVal);
      },
    },
  },
  computed: {},
  methods: {
    getChooseHospitalId(val, name) {
      this.formInline1.hospitalId = val
      this.formInline1.hospital = {
        id: val,
        name: name,
      }
      this.formInlineSubmit();
    },
    translateServiceVersionType(type) {
      let label = "";
      this.serviceVersionTypeList.forEach((item) => {
        if (item.value === type) {
          label = item.label;
        }
      });
      console.log('label', label)
      return label;
    },
    editInstanceConfig(row, index) {
      // this.teamInstanceConfig.push(row)
      this.selectInstanceRow = row;
      this.showDoctorInstance = true;
    },
    delInstanceConfig(row) {
      // this.teamInstanceConfig.splice(index,1)
      this.$confirm("是否要删除", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(async () => {
        let res = await delInstanceData(row.id);
        if (res.code == 0) {
          this.receiveInstance();
        }
      });
    },
    async upInstanceConfig(row) {
      let res = await moveUpInstance(row.id);
      if (res.code == 0) {
        this.receiveInstance();
      }
    },
    async downInstanceConfig(row) {
      let res = await moveDownInstance(row.id);
      if (res.code == 0) {
        this.receiveInstance();
      }
    },
    //查询案例配置数据
    async receiveInstance() {
      let res = await getInstanceData(this.teamIdNew);
      if (res.code == 0) {
        this.teamInstanceConfig = res.data;
      }
    },
    delTeamVedio() {
      this.addedParamData.introduceImageUrl = "";
    },
    handleAddDoctorInstance() {
      this.selectInstanceRow = {};
      this.showDoctorInstance = true;
    },
    async beforeAvatarUpload(file) {
      console.log(file);
      // return
      this.videoUploading = false;
      return new Promise(async (resolve, reject) => {
        if (file.type.indexOf("video") != -1) {
          const isLt2M = file.size / 1024 / 1024 < 100;
          const isVideo = file.type === "video/mp4";

          // const rule = /\.(m4v|mov|mp4)$/;
          if (!isVideo) {
            this.$message.error("上传只能是视频格式!");
            // this.videoValidation = false;
            return reject();
          }

          if (!isLt2M) {
            this.$message.error("上传视频大小不能超过 100MB!");
            // this.videoValidation = false;
            return reject();
          }

          //获取视频时长
          let url = URL.createObjectURL(file);
          var audioElement = new Audio(url);
          // var playTime
          audioElement.addEventListener("loadedmetadata", () => {
            let playTime = audioElement.duration; //playTime就是当前视频长度
            // console.log(Math.floor(playTime))
            if (Math.floor(playTime) / 60 > 3) {
              this.$message.error("上传视频时长不能超过3分钟!");
              // this.videoValidation = false;
              return reject();
            }
            this.videoUploading = true;
            resolve();
          });
          // console.log(playTime)
          // return reject();
        } else if (file.type.indexOf("image") != -1) {
          const isJPG =
            file.type === "image/jpg" ||
            file.type === "image/png" ||
            file.type === "image/jpeg";
          // const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
          const isLt10M = file.size / 1024 / 1024 < 10;
          if (!isJPG) {
            this.$message.error("上传图片只能是 jpg/png/jpeg 格式!");
            return reject();
          }
          if (!isLt10M) {
            this.$message.error("上传图片大小不能超过 10MB!");
            return reject();
          }

          this.videoUploading = true;
          resolve();
        } else {
          this.$message.error("请上传指定格式的图片或视频");
          return reject();
        }
      });
    },
    async handleAvatarSuccess(res, file) {
      this.videoUploading = false;
      // console.log(res,'res')
      // console.log(file,'file')
      this.addedParamData.introduceImageUrl = res.data;
      console.log(this.addedParamData.introduceImageUrl);
    },

    // 判断option病种是否需要被禁用
    isDisabledDisease(disease) {
      let flag = false;
      this.tagDiseaseList.forEach((item) => {
        if (disease === item.label) {
          flag = true;
        }
      });
      return flag;
    },
    handleServeTabClick(val) {
      this.formInline2.current = 1;
      this.formInlineGetPage1();
      this.getTeamService();
    },
    inputCusltFee(v) {},
    TeamAdministration2(scope, type) {
      let scopetItem = scope.row;
      if (type == "first") {
        if (scopetItem.doctorType == 1) {
          setAsLeader(scope.row.id).then((res) => {
            this.$message.success("操作成功");
            // this.init();
            this.detailsHandel1({ id: this.userId });
          });
        } else {
          setAsMatron(scope.row.id).then((res) => {
            this.$message.success("操作成功");
            // this.init();
            this.detailsHandel1({ id: this.userId });
          });
        }
      } else if (type == "mdt") {
        if (scope.row.mdt) {
          setAsExecutive(scope.row.id).then((res) => {
            this.$message.success("操作成功");
            // this.init();
            this.detailsHandel1({ id: this.userId });
          });
        } else {
          setAsMdt(scope.row.id).then((res) => {
            this.$message.success("操作成功");
            // this.init();
            this.detailsHandel1({ id: this.userId });
          });
        }
      } else {
        if (scope.row.platformAssist && this.userPlatForm == "organization") {
          this.$message.error("机构端不允许移除平台医辅");
          return false;
        }
        doctorMemberDelete({ id: scope.row.id }).then(async (res) => {
          this.$message.success("删除成功！");
          // this.doctorTeamMemberList.splice(scope.$index, 1);
          // this.init();
          await this.detailsHandel1({ id: this.userId });
          this.$nextTick(() => {
            this.formInlineGetPage();
          });
        });
      }
    },
    disabledChanged(e) {
      if (!e && !this.approved) {
        this.information2.disabled = true;
        this.$message.info("医生审核暂未通过，不可开通图文咨询");
        // this.$alert('医生审核暂未通过，不可开通图文咨询', '', {
        //   confirmButtonText: '确定',
        //   callback: action => {

        //   }
        // });
      }
    },
    TeamAdministration3(scope, type) {
      let scopetItem = scope.row;
      if (type == "first") {
        if (scopetItem.edit) {
          if (!scopetItem.price) {
            return this.$message.error("请输入价格");
          }
          if (!scopetItem.serviceLevel && this.activeServeTab === 'first') {
            return this.$message.error("请选择服务版本类型");
          }
          if (!/^\d+(\.\d+)?$/.test(scopetItem.price)) {
            return this.$message.error("当前价格不合理, 请理智定价");
          }
          let price = Number(scopetItem.price);
          if (price < 0 || price >= 1000000) {
            return this.$message.error("当前价格不合理, 请理智定价");
          }
          if (String(scopetItem.price).split(".").length) {
            // if (String(scopetItem.price).split(".")[0].length > 6) {
            //   return this.$message.error("当前价格不合理, 请理智定价");
            // }
            if (
              String(scopetItem.price).split(".").length == 2 &&
              String(scopetItem.price).split(".")[1].length > 2
            ) {
              return this.$message.error("当前价格不合理, 请理智定价");
            }
          }
          if (scopetItem.originalPrice) {
            if (!/^\d+(\.\d+)?$/.test(scopetItem.originalPrice)) {
              return this.$message.error("当前价格不合理, 请理智定价");
            }
            if (
              Number(scopetItem.originalPrice) <= 0 ||
              Number(scopetItem.originalPrice) >= 1000000
            ) {
              return this.$message.error("当前价格不合理, 请理智定价");
            }
            if (String(scopetItem.originalPrice).split(".").length) {
              // if (String(scopetItem.originalPrice).split(".")[0].length > 6) {
              //   return this.$message.error("当前价格不合理, 请理智定价");
              // }
              if (
                String(scopetItem.originalPrice).split(".").length == 2 &&
                String(scopetItem.originalPrice).split(".")[1].length > 2
              ) {
                return this.$message.error("当前价格不合理, 请理智定价");
              }
            }

            if (Number(scopetItem.originalPrice) < Number(scopetItem.price)) {
              return this.$message.error("原价不可小于现价");
            }
          }
          if (!scopetItem.doctorTeamId) {
            AddService({
              doctorSchemeId: scopetItem.id,
              doctorTeamId: this.userId,
              name: scopetItem.name,
              originalPrice: scopetItem.originalPrice,
              price: scopetItem.price,
              serviceLevel: this.activeServeTab === 'first' ? scopetItem.serviceLevel: 'free',
            }).then((res) => {
              this.$message.success("添加成功");
              this.formInlineGetPage1();

              this.getTeamService();
            });
            return;
          }
          updateByOriginalPrice({
            doctorSchemeId: scopetItem.doctorSchemeId,
            doctorTeamId: scopetItem.doctorTeamId,
            id: scopetItem.id,
            name: scopetItem.name,
            originalPrice: scopetItem.originalPrice,
            price: scopetItem.price,
            serviceLevel: scopetItem.serviceLevel,
          }).then((res) => {
            this.getTeamService({ id: this.userId });

            this.$message.success("操作成功");
          });
          this.$set(scope.row, "edit", false);
          //
          // }).then(res=>{

          // })
        } else {
          this.$set(scope.row, "edit", true);
          scope.row.edit = true;
        }
        this.$forceUpdate();
      } else if (type == "second") {
        setAsRecommend({
          id: scopetItem.id,
          value: !scopetItem.recommend,
        }).then((res) => {
          this.getTeamService();

          this.$message.success("操作成功");
        });
      } else {
        doctorServiceDelete(scope.row.id).then(async (res) => {
          this.$message.success("删除成功");
          this.teamServiceList.splice(scope.$index, 1);

          await this.getTeamService();

          this.formInlineGetPage1();
        });
        // this.teamServiceList.splice(scope.$index,1);
      }
    },
    async showFront(row) {
      // 前端展示
      let { code, data } = await updatePatientShow({
        id: row.id,
        show: !row.patientShow,
      });
      if (code === 0) {
        // 获取列表接口
        this.getTeamService();
        this.$message.success("操作成功");
      }
    },
    choisePerson2(data, index) {
      AdddoctorMember({
        doctorId: data.id,
        doctorTeamId: this.userId,
      }).then(async (res) => {
        await this.detailsHandel1({ id: this.userId });
        this.formInlineSubmit();

        this.$message.success("操作成功");
      });
    },
    choisePerson3(data, index) {
      // AddService({
      // 	doctorSchemeId:data.id,
      // 	doctorTeamId:this.userId,
      // 	name:data.name
      // }).then(res=>{
      for (let i = 0; i < this.teamServiceList.length; i++) {
        if (this.teamServiceList[i].edit === true) {
          return this.$message.info("请保存信息");
        }
      }
      this.teamServiceList.push({
        doctorSchemeId: data.id,
        ...data,
        originalPrice: "",
        price: "",

        edit: true,
      });
      this.formInlineGetPage1();
      // })
    },
    // 详情弹框点编辑
    detailEdit() {
      this.isEdit1 = true;
      this.addedParamData.caseMgrGroup = this.addedParamData.caseMgrGroupName;
      this.addedParamData.hospitall = this.addedParamData.hospitalName;
    },
    choisePerson1(data, index) {
      this.teamServiceList.push({
        doctorSchemeId: data.id,
        ...data,
        edit: true,
      });
      this.formInlineGetPage1();
    },
    serviceOpen() {
      this.ServiceListIf = !this.ServiceListIf;
      let leader = false;
      for (var i = 0; i < this.doctorTeamMemberList.length; i++) {
        if (
          this.doctorTeamMemberList[i].doctorType == 1 &&
          this.doctorTeamMemberList[i].leader
        ) {
          leader = true;
        }
      }
      if (!leader) {
        return this.$message.info("没有领衔医生不可绑定服务, 请先选择领衔医生");
      }
      if (this.ServiceListIf) {
        this.formInlineSubmit1();
      }
    },
    TeamAdministration(scope, type) {
      let scopetItem = scope.row;
      if (type == "first") {
        if (scopetItem.doctorType == 1) {
          for (let i = 0; i < this.doctorTeamMemberList.length; i++) {
            if (this.doctorTeamMemberList[i].leader) {
              this.$set(this.doctorTeamMemberList[i], "mdt", true);
            }
            if (i == scope.$index) {
              continue;
            }
            this.$set(this.doctorTeamMemberList[i], "leader", false);
          }
          this.$set(this.doctorTeamMemberList[scope.$index], "leader", true);
          this.$set(this.doctorTeamMemberList[scope.$index], "mdt", false);
          // 	this.doctorTeamMemberList[i].leader = false;
          // }
          // this.doctorTeamMemberList[scope.$index]['leader'] = !scopetItem.leader;
        } else if (scopetItem.doctorType == 2) {
          for (let i = 0; i < this.doctorTeamMemberList.length; i++) {
            if (i == scope.$index) {
              continue;
            }
            // this.doctorTeamMemberList[i].matron = false;
            this.$set(this.doctorTeamMemberList[i], "matron", false);
          }
          this.$set(
            this.doctorTeamMemberList[scope.$index],
            "matron",
            !scopetItem.matron
          );
          // this.doctorTeamMemberList[scope.$index]['matron'] = !scopetItem.matron;
        }
        this.$forceUpdate();
        return;
      } else if (type == "mdt") {
        this.$set(
          this.doctorTeamMemberList[scope.$index],
          "mdt",
          !this.doctorTeamMemberList[scope.$index].mdt
        );
      } else {
        // this.$confirm('此操作将删除该成员, 是否继续?', '提示', {
        // 	confirmButtonText: '确定',
        // 	cancelButtonText: '取消',
        // 	type: 'warning',
        // 	customClass: 'message-confirm-style'
        // }).then(() => {

        // this.tableData1.push(scope.row);
        this.doctorTeamMemberList.splice(scope.$index, 1);
        this.formInlineGetPage();
        // removeInfo(scopetItem.id).then((res) => {
        // 	if (res.code == 0) {
        // 		let index = this.informationDetails.memberList.findIndex((sub) => sub.id ==
        // 			scopetItem.id)
        // 		this.informationDetails.memberList.splice(index, 1)
        // 		this.init()
        // 	} else {
        // 		this.$message.error(`${res.message}`)
        // 	}
        // })
        // })
      }
    },
    TeamAdministration1(scope, type) {
      let scopetItem = scope.row;
      if (type == "first") {
        if (scopetItem.edit) {
          if (!scopetItem.price || !scopetItem.originalPrice) {
            return this.$message.error("请输入价格");
          }
          if (scopetItem.price < 0 || scopetItem.originalPrice < 0) {
            return this.$message.error("价格不能为负数");
          }
          if (String(scopetItem.price).split(".").length) {
            if (String(scopetItem.price).split(".")[0].length > 6) {
              return this.$message.error("当前价格不合理, 请理智定价");
            }
            if (
              String(scopetItem.price).split(".").length == 2 &&
              String(scopetItem.price).split(".")[1].length > 2
            ) {
              return this.$message.error("当前价格不合理, 请理智定价");
            }
          }
          if (String(scopetItem.originalPrice).split(".").length) {
            if (String(scopetItem.originalPrice).split(".")[0].length > 6) {
              return this.$message.error("当前价格不合理, 请理智定价");
            }
            if (
              String(scopetItem.originalPrice).split(".").length == 2 &&
              String(scopetItem.originalPrice).split(".")[1].length > 2
            ) {
              return this.$message.error("当前价格不合理, 请理智定价");
            }
          }
          if (scopetItem.price < scopetItem.originalPrice) {
            return this.$message.error("原价不可小于现价");
          }
          scope.row.edit = false;
        } else {
          scope.row.edit = true;
        }
        this.$forceUpdate();
      } else {
        this.teamServiceList.splice(scope.$index, 1);
        this.formInlineGetPage1();
      }
    },
    addPeopel() {
      this.sysListIf = !this.sysListIf;
      if (this.sysListIf) {
        this.formInlineSubmit();
      }
    },

    /**
     * @description: 线下机构列表
     */
    getHospitalListHandel() {
      plateFormOn().then((res) => {
        if (res.code == 0) {
          this.hospitalOptions = res.data;
        }
      });
    },

    submiAddCare6(ref) {
      this.$refs[ref].validate(async (valid) => {
        if (valid) {
          if (!this.information2.disabled) {
            var consultFee = Number(this.information2.consultFee);
            var serviceTime = Number(this.information2.serviceTime);
            if (consultFee <= 0 || consultFee > 9999.99) {
              return this.$message.error("请按要求填写咨询费");
            }
            if (serviceTime <= 0 || serviceTime > 24) {
              return this.$message.error("请按要求填写服务时长");
            }
            if (String(this.information2.serviceTime).split(".").length) {
              if (
                String(this.information2.serviceTime).split(".").length == 2 &&
                String(this.information2.serviceTime).split(".")[1].length > 1
              ) {
                return this.$message.error("请按要求填写服务时长");
              }
            }
            if (String(this.information2.consultFee).split(".").length) {
              if (
                String(this.information2.consultFee).split(".").length == 2 &&
                String(this.information2.consultFee).split(".")[1].length > 2
              ) {
                return this.$message.error("请按要求填写咨询费");
              }
            }
          }
          if (!this.information2.synergyDisabled) {
            var synergyTextConsultFee = Number(
              this.information2.synergyTextConsultFee
            ); //图文咨询费
            var synergyVideoConsultFee = Number(
              this.information2.synergyVideoConsultFee
            ); //视频咨询费
            var synergyServiceTime = Number(
              this.information2.synergyServiceTime
            );
            console.log(isNaN(synergyTextConsultFee), "synergyTextConsultFee");
            if (
              synergyTextConsultFee < 0 ||
              synergyTextConsultFee > 9999.99 ||
              isNaN(synergyTextConsultFee)
            ) {
              return this.$message.error("请按要求填写图文咨询费");
            }
            if (
              synergyVideoConsultFee < 0 ||
              synergyVideoConsultFee > 9999.99 ||
              isNaN(synergyVideoConsultFee)
            ) {
              return this.$message.error("请按要求填写视频咨询费");
            }
            if (synergyServiceTime <= 0 || synergyServiceTime > 24) {
              return this.$message.error("请按要求填写服务时长");
            }
            if (
              String(this.information2.synergyServiceTime).split(".").length
            ) {
              if (
                String(this.information2.synergyServiceTime).split(".")
                  .length == 2 &&
                String(this.information2.synergyServiceTime).split(".")[1]
                  .length > 1
              ) {
                return this.$message.error("请按要求填写服务时长");
              }
            }
            if (
              String(this.information2.synergyTextConsultFee).split(".").length
            ) {
              if (
                String(this.information2.synergyTextConsultFee).split(".")
                  .length == 2 &&
                String(this.information2.synergyTextConsultFee).split(".")[1]
                  .length > 2
              ) {
                return this.$message.error("请按要求填写图文咨询费");
              }
            }
            if (
              String(this.information2.synergyVideoConsultFee).split(".").length
            ) {
              if (
                String(this.information2.synergyVideoConsultFee).split(".")
                  .length == 2 &&
                String(this.information2.synergyVideoConsultFee).split(".")[1]
                  .length > 2
              ) {
                return this.$message.error("请按要求填写视频咨询费");
              }
            }
          }
          inquiry_config({
            refId: this.addedParamData.id,
            belong: 2,
            disabled: this.information2.disabled,
            consultFee: consultFee * 100,
            serviceTime: serviceTime,
            describe: this.information2.describe,
            id: this.information2.id,
            freeClinicsDisabled: this.information2.freeClinicsDisabled,
            synergyDisabled: this.information2.synergyDisabled,
            synergyTextConsultFee:
              this.information2.synergyTextConsultFee * 100,
            synergyVideoConsultFee:
              this.information2.synergyVideoConsultFee * 100,
            synergyServiceTime:
              this.information2.synergyServiceTime == ""
                ? 0
                : this.information2.synergyServiceTime,
            synergyDescribe: this.information2.synergyDescribe,
          }).then((res) => {
            this.isEdit4 = false;
            inquiry_config_detailByRefId({ refId: this.$route.query.id }).then(
              (res) => {
                this.information2.disabled = res.data.disabled;
                this.information2.consultFee = res.data.consultFee
                  ? res.data.consultFee / 100
                  : "";
                this.information2.serviceTime = res.data.serviceTime
                  ? res.data.serviceTime
                  : "";
                this.information2.describe = res.data.describe;

                (this.information2.synergyDisabled = res.data.synergyDisabled),
                  (this.information2.synergyTextConsultFee =
                    res.data.synergyTextConsultFee != null
                      ? res.data.synergyTextConsultFee / 100
                      : "");
                this.information2.synergyVideoConsultFee =
                  res.data.synergyVideoConsultFee != null
                    ? res.data.synergyVideoConsultFee / 100
                    : "";

                this.information2.synergyServiceTime = res.data
                  .synergyServiceTime
                  ? res.data.synergyServiceTime
                  : "";
                this.information2.synergyDescribe = res.data.synergyDescribe;
              }
            );
          });
        } else {
        }
      });
    },
    getPlatformDepartmentListHandel(res) {
      //TODO 根据平台id得到科室id
      getPlatformDepartmentList({
        platformId: res.platformId,
      }).then((res) => {
        if (res.code == 0) {
          this.departmentList = res.data;
        }
      });
    },
    /**
     * @description: 首页查看详情
     * @param {*}
     * @return {*}
     */
    detailsHandel(scope, activeName) {
      this.activeName1 = 1;

      // return
      this.userId = this.$route.query.id; //dectortemId
      doctorTeam(this.userId).then((res) => {
        if (res.code == 0) {
          // addedParamData
          Object.keys(this.addedParamData).forEach((item) => {
            this.addedParamData[item] = res.data[item];
            //TODO 拿到后端返回的半路经进行拼接展示

            if (
              [
                "avatarImageUrl",
                "backgroundImageUrl",
                "messagePushImageUrl",
              ].includes(item)
            ) {
              this.addedParamData[item] =
                res.data[item] && `${imgBaseURL}` + res.data[item];
            }
          });
          this.approved = res.data.approved;
          this.getTeamService();
          console.log(res.data.memberList, "res.data.memberList");
          this.doctorTeamMemberList = res.data.memberList;
          // this.teamServiceList = res.data.teamServiceList;
          this.hospitalNewId = res.data.hospitalId;
          this.openDepartmentIdNew = res.data.openDepartmentId;
          this.openDepartmentParentIdNew = res.data.openDepartmentId;
          this.teamIdNew = res.data.id;

          this.teamInstanceConfig = res.data.doctorTeamCaseConfigVOList;
          console.log(res.data, "res.data");
          this.fiveFlag = true;
          // this.commonQueryRequest();
          this.getPlatformDepartmentListHandel({
            platformId: this.$route.query.platformId,
          });
          // this.searchPatientHandel();
          let hospitall = {};
          this.hospitalOptions.forEach((item) => {
            if (item.id === res.data.hospitalId) {
              hospitall = item;
            }
          });
          this.$set(this.addedParamData, "hospitall", hospitall);
          treeList({
            hospitalId: res.data.hospitalId,
            // 平台id
            companyId: this.$store.state.companyId,
            platformId: res.data.platformId,
            type: 2,
          }).then((ress) => {
            if (ress.code == 0) {
              ress.data.forEach((items) => {
                if (items.id === res.data.caseMgrGroupId) {
                  this.$set(this.addedParamData, "caseMgrGroup", items);
                }
              });
            }
          });
        }
      });
      inquiry_config_detailByRefId({ refId: this.$route.query.id }).then(
        (res) => {
          this.information2.id = res.data.id;
          this.information2.disabled = res.data.disabled;
          this.information2.consultFee = res.data.consultFee
            ? res.data.consultFee / 100
            : "";
          this.information2.serviceTime = res.data.serviceTime
            ? res.data.serviceTime
            : "";
          this.information2.describe = res.data.describe;

          (this.information2.synergyDisabled = res.data.synergyDisabled),
            (this.information2.synergyTextConsultFee =
              res.data.synergyTextConsultFee != null
                ? res.data.synergyTextConsultFee / 100
                : "");
          this.information2.synergyVideoConsultFee =
            res.data.synergyVideoConsultFee != null
              ? res.data.synergyVideoConsultFee / 100
              : "";

          this.information2.synergyServiceTime = res.data.synergyServiceTime
            ? res.data.synergyServiceTime
            : "";
          this.information2.synergyDescribe = res.data.synergyDescribe;
        }
      );
      this.addHospitalChange();
    },
    detailsHandel1(scope, activeName) {
      return new Promise((resolve, reject) => {
        doctorTeam(this.userId).then((res) => {
          if (res.code == 0) {
            // addedParamData

            Object.keys(this.addedParamData).forEach((item) => {
              this.addedParamData[item] = res.data[item];
              //TODO 拿到后端返回的半路经进行拼接展示

              if (
                [
                  "avatarImageUrl",
                  "backgroundImageUrl",
                  "messagePushImageUrl",
                ].includes(item)
              ) {
                this.addedParamData[item] =
                  res.data[item] && `${imgBaseURL}` + res.data[item];
              }
            });
            console.log(this.addedParamData);
            this.approved = res.data.approved;
            this.getTeamService();
            this.doctorTeamMemberList = res.data.memberList;

            // this.addedParamData.hospitalId = res.data.hospitalId

            // this.addedParamData.openDepartmentId = res.data.openDepartmentId;
            // this.addedParamData.caseMgrGroupId = res.data.caseMgrGroupId
            this.getPlatformDepartmentListHandel({
              platformId: this.$route.query.platformId,
            });
            // this.searchPatientHandel();
            let hospitall = {};
            this.hospitalOptions.forEach((item) => {
              if (item.id === res.data.hospitalId) {
                hospitall = item;
              }
            });
            this.$set(this.addedParamData, "hospitall", hospitall);
            resolve();
            treeList({
              hospitalId: res.data.hospitalId,
              // 平台id
              companyId: this.$store.state.companyId,
              platformId: res.data.platformId,
              type: 2,
            }).then((ress) => {
              if (ress.code == 0) {
                ress.data.forEach((items) => {
                  if (items.id === res.data.caseMgrGroupId) {
                    this.$set(this.addedParamData, "caseMgrGroup", items);
                  }
                });
              }
            });
          }
          inquiry_config_detailByRefId({ refId: this.$route.query.id }).then(
            (res) => {
              this.information2.id = res.data.id;
              this.information2.disabled = res.data.disabled;
              this.information2.consultFee = res.data.consultFee
                ? res.data.consultFee / 100
                : "";
              this.information2.serviceTime = res.data.serviceTime
                ? res.data.serviceTime
                : "";
              this.information2.describe = res.data.describe;

              (this.information2.synergyDisabled = res.data.synergyDisabled),
                (this.information2.synergyTextConsultFee =
                  res.data.synergyTextConsultFee != null
                    ? res.data.synergyTextConsultFee / 100
                    : "");
              this.information2.synergyVideoConsultFee =
                res.data.synergyVideoConsultFee != null
                  ? res.data.synergyVideoConsultFee / 100
                  : "";

              this.information2.synergyServiceTime = res.data.synergyServiceTime
                ? res.data.synergyServiceTime
                : "";
              this.information2.synergyDescribe = res.data.synergyDescribe;
            }
          );
          // this.addHospitalChange()
        });
      });
    },
    getTeamService(id) {
      getServiceByTeamId(
        this.userId,
        this.activeServeTab == "first" ? false : true
      ).then((res) => {
        this.$nextTick(() => {
          this.teamServiceList = res.data;
        });
      });
    },
    resetHandel1() {
      this.formInline1.keyword = "";

      this.formInlineSubmit();
    },
    resetHandel2() {
      this.formInline2.name = "";

      this.formInlineSubmit1();
    },
    handleCurrentChange1(val) {
      this.formInline2.current = val;
      this.formInlineGetPage1();
    },
    handleSizeChange1(val) {
      this.formInline2.size = val;
      this.formInlineGetPage1();
    },
    handleCurrentChange(val) {
      this.formInline1.current = val;
      this.formInlineGetPage();
    },
    handleSizeChange(val) {
      this.formInline1.size = val;
      this.formInlineGetPage();
    },

    formInlineSubmit1() {
      this.formInline2.current = 1;
      this.formInlineGetPage1();
    },
    formInlineGetPage1() {
      this.$nextTick(() => {
        let leaderId = null;
        for (let i = 0; i < this.doctorTeamMemberList.length; i++) {
          if (
            this.doctorTeamMemberList[i].leader &&
            this.doctorTeamMemberList[i].doctorType == 1
          ) {
            leaderId = this.doctorTeamMemberList[i].doctorId;
          }
        }
        if (!leaderId) {
          return;
        }
        doctorSearch1({
          notDisplayList: this.teamServiceList.map((item) => {
            return item.doctorSchemeId;
          }),
          leaderId,
          ...this.formInline2,
          experiencePack: this.activeServeTab == "first" ? false : true,
        }).then((res) => {
          if (res.code == 0) {
            this.tableData2 = res.data.records;
            this.formInline2.total = res.data.total;
            return true;
          }
        });
      });
    },
    formInlineSubmit() {
      this.formInline1.current = 1;
      this.formInlineGetPage();
    },
    formInlineGetPage() {
      this.$nextTick(() => {
        addMemberSearch({
          keywordSearchField: ["openDepartment"],
          notDisplayList: this.doctorTeamMemberList.map((item) => {
            return item.doctorId;
          }),
          orderList: ["name"],
          searchPage: "doctorTeam",
          companyId: this.$store.state.companyId,
          platformId: this.$store.state.platformId,
          hospitalId:
            this.addedParamData.hospitalId || this.$store.state.hospitalId,
          ...this.formInline1,
        }).then((res) => {
          this.tableData1 = res.data.records;
          this.formInline1.total = res.data.total;
          return true;
        });
      });
    },
    closeaddCare() {
      this.$refs["addedParamData"].resetFields();
      this.addedParamData.avatarImageUrl = "";
      this.addedParamData.backgroundImageUrl = "";
      this.addedParamData.messagePushImageUrl = "";
      this.addedParamData.name = "";
      this.addedParamData.introduction = "";
      this.addedParamData.professional = "";
      this.addedParamData.caseMgrGroupId = "";
      this.addedParamData.caseMgrGroup = {};
      this.addedParamData.departmentId = "";
      this.addedParamData.platformId = "";
      this.addedParamData.hospitalId = "";
      this.addedParamData.hospitall = {};
      this.addedParamData.hospitalName = "";
      this.addedParamData.openDepartmentId = "";
      this.addedParamData.openDepartmentName = "";
      this.$nextTick(() => {
        this.$refs["addedParamData"].clearValidate();
      });
    },
    beforeUpLFnHos() {
      if (
        this.$store.state.userPlatForm === "platForm" &&
        !this.addedParamData.hospitalId
      ) {
        this.$message.info("请先选择线下机构");
        return false;
      }
      return true;
    },
    // 团队科室
    openDepartmentChange(val) {
      this.addedParamData.openDepartmentName = "";
      this.$nextTick(() => {
        this.addedParamData.openDepartmentName =
          this.$refs["Mycascader"].getCheckedNodes()[0].label;
      });
    },
    /**
     * @description: 团队图片上传
     * @param {*} response
     * @param {*} file
     * @param {*} fileList
     * @return {*}
     */
    handleResponse(response) {
      if (response.code == 0) {
        return (this.addedParamData.avatarImageUrl =
          `${process.env.VUE_APP_OSS_URL}` + response.data);
      }
    },
    /**
     * @description: 背景图片上传
     * @param {*} response
     * @param {*} file
     * @param {*} fileList
     * @return {*}
     */
    handleBackgroundResponse(response) {
      if (response.code == 0) {
        return (this.addedParamData.backgroundImageUrl =
          `${process.env.VUE_APP_OSS_URL}` + response.data);
      }
    },

    /**
     * @description: 消息推送上传 上传成功后会返回一个mediaID
     * @param {*} response
     * @param {*} file
     * @param {*} fileList
     * @return {*}
     */
    handleMessageResponse(response) {
      // if (!this.addedParamData.platformId) {
      //   // this.$message.info("请先选择归属平台");
      //   return false;
      // }
      // if(!this.addedParamData.platformId) return this.$message.error('请先选择归属平台')
      if (response.code == 0) {
        this.addedParamData.mediaId = response.data.media_id;
        return (this.addedParamData.messagePushImageUrl =
          `${process.env.VUE_APP_OSS_URL}` + response.data.ossUrl);
      } else {
        this.$message.error(response.message);
      }
    },
    handleTabClick(tab) {
      this.activeName1 = tab;
      if (tab == 1) {
        this.bigStatus = false;
      } else if (tab == 2) {
        this.bigStatus = false;
        if (this.$store.state.userPlatForm === 'platForm') {
          this.formInline1.hospitalId = this.addedParamData.hospitalId
          this.formInline1.hospital = {
            id: this.addedParamData.hospitalId,
            name: this.addedParamData.hospitall.name,
          }

        }
        this.formInlineSubmit();
      } else if (tab == 3) {
        this.bigStatus = false;
        this.formInlineSubmit1();
      } else if (tab == 4) {
        this.bigStatus = false;
      } else if (tab == 5) {
        this.getDiseaseType();
        // 调用已配置病种接口
        this.focusFieldConfig();
      }
    },
    //
    async focusFieldConfig() {
      let { code, data } = await focusFieldConfig(this.teamIdNew);
      if (code === 0) {
        if (data) {
          this.tagDiseaseList = data.map((item) => {
            return {
              ...item,
              label: item.diseaseName,
            };
          });
          this.paramData.diseaseId = data[0].diseaseId;
          this.diseaseId = data[0].diseaseId;
          this.diseaseActive = data[0].diseaseName;
          this.$nextTick(() => {
            let boxWidth = document.querySelector(".tabs-box").offsetWidth;
            let arr = document.querySelectorAll(".sub-tabs-list");
            let btnWidth = this.$refs.fold.offsetWidth;
            this.variable(boxWidth, arr, btnWidth)
              .then((res) => {
                this.foldIndex = res - 1;
                console.log("foldIndex", this.foldIndex);
              })
              .catch((error) => {
                // 此处不足一行时我将按钮隐藏了
                // this.$refs.fold.style.display = error
                // console.error(error);
              });
          });
        }
      }
    },
    submiAddCare5(ref) {
      console.log("医护团队基本信息修改保存");
      this.$refs["addedParamData"].validate((valid) => {
        if (!this.addedParamData.avatarImageUrl) {
          return this.$message.error("请上传团队头像");
        }
        if (!this.addedParamData.backgroundImageUrl) {
          return this.$message.error("请上传团队背景图");
        }
        if (!this.addedParamData.messagePushImageUrl) {
          return this.$message.error("请上传消息推送图");
        }
        if (valid) {
          let obj = { ...this.addedParamData };
          Object.keys(obj).forEach((item) => {
            if (
              [
                "avatarImageUrl",
                "backgroundImageUrl",
                "messagePushImageUrl",
              ].includes(item)
            ) {
              obj[item] = obj[item].substring(
                process.env.VUE_APP_OSS_URL.length
              );
            }
          });
          doctorUpdate({
            ...obj,
          }).then((res) => {
            this.isEdit1 = false;
            console.log(obj);
            this.$message.success("操作成功");
            this.detailsHandel1({ id: this.userId });
          });
        }
      });
    },
    /**
     *
     * 关闭新增医护弹回调
     */
    closeaddCare5() {
      this.doctorCertificateSubmitDTO.idCard = {
        back: "",
        front: "",
        watermarkBack: "",
        watermarkFront: "",
      };
      (this.doctorCertificateSubmitDTO.other = {
        files: [],
        fileList: [],
        watermarkFiles: "",
      }),
        (this.doctorCertificateSubmitDTO.practice = {
          files: [],
          fileList: [],
          number: "",
          obtainDate: "",
          watermarkFiles: "",
        }),
        (this.doctorCertificateSubmitDTO.qualification = {
          files: [],
          fileList: [],
          obtainDate: "",
          number: "",
          watermarkFiles: "",
        });
      this.doctorCertificateSubmitDTO.title = {
        files: [],
        fileList: [],
        obtainDate: "",
        number: "",
        watermarkFiles: "",
      };
      this.doctorCertificateSubmitDTO.nameBadge = {
        files: [],
        fileList: [],
        obtainDate: "",
        number: "",
        watermarkFiles: "",
      };
    },
    submiAddCare4() {
      let obj = { ...this.addedParamData };
      Object.keys(obj).forEach((item) => {
        if (
          [
            "avatarImageUrl",
            "backgroundImageUrl",
            "messagePushImageUrl",
          ].includes(item)
        ) {
          obj[item] = obj[item].substring(process.env.VUE_APP_OSS_URL.length);
        }
      });
      doctorTeamCreate({
        ...obj,
        teamServiceList: this.teamServiceList,
        doctorTeamMemberList: this.doctorTeamMemberList,
        caseMgrGroupId: this.addedParamData.caseMgrGroupId,
      }).then((res) => {
        this.dialogVisible = false;
        this.$message.success("操作成功");
        this.reset();
      });
    },
    submiAddCare3() {
      for (let i = 0; i < this.teamServiceList.length; i++) {
        if (this.teamServiceList[i].edit) {
          return this.$message.error("有信息未保存");
        }
      }
      this.submiAddCare4();
    },

    handleMessageResponse2(response) {
      if (response.code == 0) {
        return (this.upavater = `${process.env.VUE_APP_OSS_URL}${response.data}`);
      }
    },
    handleMessageResponse3(res) {
      if (res.code !== 0) {
        return;
      }
      this.doctorCertificateSubmitDTO.idCard.watermarkBack = `${process.env.VUE_APP_OSS_URL}${res.data.watermarkUrl}`;
      return (this.doctorCertificateSubmitDTO.idCard.back = `${process.env.VUE_APP_OSS_URL}${res.data.sourceUrl}`);
    },
    handleMessage3beforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.idCard.watermarkFiles.split(',').length - 1 < index){
      //  return;
      // }
      // let str = this.doctorCertificateSubmitDTO.idCard.watermarkFront.split(',').splice(index,1).join(',');
      this.doctorCertificateSubmitDTO.idCard.watermarkBack = "";
    },
    handleMessageResponse4(res) {
      if (res.code !== 0) {
        return;
      }
      this.doctorCertificateSubmitDTO.idCard.watermarkFront = `${process.env.VUE_APP_OSS_URL}${res.data.watermarkUrl}`;
      return (this.doctorCertificateSubmitDTO.idCard.front = `${process.env.VUE_APP_OSS_URL}${res.data.sourceUrl}`);
    },
    handleMessage4beforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.idCard.watermarkFiles.split(',').length - 1 < index){
      //  return;
      // }
      // let str = this.doctorCertificateSubmitDTO.idCard.watermarkFront.split(',').splice(index,1).join(',');
      this.doctorCertificateSubmitDTO.idCard.watermarkFront = "";
    },
    /**
     * @description: 上传资格证图片
     * @event:
     * @param {*}
     * @return {*}
     */
    certificateQualificationResponse(response) {
      if (response.code == 0) {
        // setTimeout(() => {
        // 	this.add()
        // }, 100)
        let a = `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`;
        if (
          this.doctorCertificateSubmitDTO.qualification.watermarkFiles == ""
        ) {
          this.doctorCertificateSubmitDTO.qualification.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr =
            this.doctorCertificateSubmitDTO.qualification.watermarkFiles.split(
              ","
            );
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.qualification.watermarkFiles =
            arr.join(",");
        }

        return this.doctorCertificateSubmitDTO.qualification.files.push(a);
      }
    },
    certificateQualificationbeforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.qualification.watermarkFiles.split(',').length - 1 < index && !(this.doctorCertificateSubmitDTO.qualification.watermarkFiles.split(',').length === 1 && index===0)){
      //  return;
      // }
      let str =
        this.doctorCertificateSubmitDTO.qualification.watermarkFiles.split(",");
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.qualification.watermarkFiles =
        str.join(",");
    },
    /**
     * @description: 执业证上传
     * @event:
     * @param {*}
     * @return {*}
     */
    practiceUploadImage(response) {
      if (response.code == 0) {
        // setTimeout(() => {

        // 	this.add()
        // }, 100)
        if (this.doctorCertificateSubmitDTO.practice.watermarkFiles == "") {
          this.doctorCertificateSubmitDTO.practice.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr =
            this.doctorCertificateSubmitDTO.practice.watermarkFiles.split(",");
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.practice.watermarkFiles =
            arr.join(",");
        }
        return this.doctorCertificateSubmitDTO.practice.files.push(
          `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`
        );
      }
    },
    practicebeforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.practice.watermarkFiles.split(',').length - 1 < index && !(this.doctorCertificateSubmitDTO.practice.watermarkFiles.split(',').length === 1 && index===0)){
      //  return;
      // }
      let str =
        this.doctorCertificateSubmitDTO.practice.watermarkFiles.split(",");
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.practice.watermarkFiles = str.join(",");
      // this.doctorCertificateSubmitDTO.practice.watermarkFiles = str;
    },
    /**
     * @description: 职称证上传
     * @event:
     * @param {*} e
     * @return {*}
     */
    certificatePracticeResponse(response) {
      if (response.code == 0) {
        // setTimeout(() => {
        // 	this.add()
        // }, 100)
        if (this.doctorCertificateSubmitDTO.title.watermarkFiles == "") {
          this.doctorCertificateSubmitDTO.title.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr =
            this.doctorCertificateSubmitDTO.title.watermarkFiles.split(",");
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.title.watermarkFiles = arr.join(",");
        }
        return this.doctorCertificateSubmitDTO.title.files.push(
          `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`
        );
      }
    },
    certificatePracticebeforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.title.watermarkFiles.split(',').length - 1 < index && !(this.doctorCertificateSubmitDTO.title.watermarkFiles.split(',').length === 1 && index===0)){
      //  return;
      // }
      let str = this.doctorCertificateSubmitDTO.title.watermarkFiles.split(",");
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.title.watermarkFiles = str.join(",");
      // this.doctorCertificateSubmitDTO.title.watermarkFiles = str;
    },
    // 胸牌
    certificateNameBadgeResponse(response) {
      if (response.code == 0) {
        // setTimeout(() => {
        // 	this.add()
        // }, 100)
        if (this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles == "") {
          this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr =
            this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles.split(",");
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles =
            arr.join(",");
        }
        return this.doctorCertificateSubmitDTO.nameBadge.files.push(
          `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`
        );
      }
    },
    certificateNameBadgebeforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.title.watermarkFiles.split(',').length - 1 < index && !(this.doctorCertificateSubmitDTO.title.watermarkFiles.split(',').length === 1 && index===0)){
      //  return;
      // }
      let str =
        this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles.split(",");
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles = str.join(",");
      // this.doctorCertificateSubmitDTO.title.watermarkFiles = str;
    },
    /**
     * @description: 其他相关证书上传
     * @event:
     * @param {*} e
     * @return {*}
     */
    certificateOtherUplod(response) {
      if (response.code == 0) {
        // setTimeout(() => {
        // 	this.add()
        // }, 100)
        if (this.doctorCertificateSubmitDTO.other.watermarkFiles == "") {
          this.doctorCertificateSubmitDTO.other.watermarkFiles =
            response.data.watermarkUrl;
        } else {
          let arr =
            this.doctorCertificateSubmitDTO.other.watermarkFiles.split(",");
          arr.push(response.data.watermarkUrl);

          this.doctorCertificateSubmitDTO.other.watermarkFiles = arr.join(",");
        }
        return this.doctorCertificateSubmitDTO.other.files.push(
          `${process.env.VUE_APP_OSS_URL}${response.data.sourceUrl}`
        );
      }
    },
    certificateOtherbeforeRemove(file, fileList, index) {
      // if(this.doctorCertificateSubmitDTO.other.watermarkFiles.split(',').length - 1 < index && !(this.doctorCertificateSubmitDTO.other.watermarkFiles.split(',').length === 1 && index===0)){
      //  return;
      // }

      let str = this.doctorCertificateSubmitDTO.other.watermarkFiles.split(",");
      str.splice(index, 1);
      this.doctorCertificateSubmitDTO.other.watermarkFiles = str.join(",");
    },
    radioChangeGrounp(e) {
      // this.doctorTeamId = '';
      // if(e == false){
      // this.departmentList1 = [];//归属科室
      // this.caseMgrGroupList = [];//个案组列表
      this.doctorTeam.name = "";
      this.doctorTeam.id = "";
      this.doctorTeam.platformId = "";
      this.doctorTeam.departmentId = "";
      this.doctorTeam.caseMgrGroupId = "";
      this.doctorTeam.openDepartmentId = "";
    },
    doctorTeamChange(val) {
      this.doctorTeam.doctorTeamName = "";
      for (var i = 0; i < this.doctorTeamList.length; i++) {
        if (this.doctorTeamList[i].id == val) {
          this.doctorTeam.doctorTeamName = this.doctorTeamList[i].name;
        }
      }
    },
    departmentTeamChange() {
      this.doctorTeam.departmentName = "";
      this.$nextTick(() => {
        this.doctorTeam.departmentName =
          this.$refs["Mycascader1"].getCheckedNodes()[0].label;
      });
    },
    caseMgrGroupChange(val) {
      this.doctorTeam.caseMgrGroupName = "";
      for (var i = 0; i < this.caseMgrGroupList.length; i++) {
        if (this.caseMgrGroupList[i].id == val) {
          this.doctorTeam.caseMgrGroupName = this.caseMgrGroupList[i].name;
        }
      }
    },
    PreviousStep() {
      // this.flagId = this.information1.hospitalId;
      this.activeName1 -= 1;
    },
    hospitalChange(val) {
      this.hospitalId = val;
      if (this.information1.doctorType == 2) {
        // getHaveNursingService(val).then(res=>{
        // 	this.haveService = res.data
        // })
      }
      if (this.userPlatForm == "platForm") {
        this.getTreeList(
          this.userPlatForm == "platForm"
            ? this.information1.hospitalId
            : local.get("hospitalId")
        );
        if (this.information1.hospitalId) {
          getPlatformOpenDepartmentList({
            hospitalId: this.information1.hospitalId,
          }).then((res) => {
            if (res.code == 0) {
              this.departmentList1 = res.data;
            }
          });
        }
      } else {
        for (var i = 0; i < this.platformOptions.length; i++) {
          if (this.platformOptions[i].id == this.information1.hospitalId) {
            this.doctorTeam.platformName = this.platformOptions[i].name;
          }
        }
      }

      this.hospitalList.forEach((item) => {
        if (item.id == val) {
          this.doctorTeam.hospitalId = item.id;
          this.doctorTeam.hospitalName = item.name;
        }
      });

      this.information1.hospitalName = "";
      for (var i = 0; i < this.hospitalList.length; i++) {
        if (
          this.hospitalList[i].id == val ||
          this.hospitalList[i].id == this.information1.hospitalId
        ) {
          this.information1.hospitalName = this.hospitalList[i].name;
        }
      }
      this.apiDoctorTeamSearchinit(val);
      if (this.dialogVisible) {
        this.information1.departmentId = "";
      }

      api_department({
        hospitalId: val,
      }).then((res) => {
        if (res.code == 0) {
          this.departmentList = res.data;
        }
      });
    },
    departmentChange(val) {
      this.information1.departmentName = "";
      if (!this.$refs["Mycascader"].getCheckedNodes().length) {
        return;
      }
      this.$nextTick(() => {
        this.information1.departmentName =
          this.$refs["Mycascader"].getCheckedNodes()[0].label;
      });
    },
    apiDoctorTeamSearchinit(id) {
      let val = id ? id : null;
      api_doctor_team({
        disabled: false,
        hospitalId: val,
      }).then((res) => {
        this.doctorTeamList = res.data;
      });
    },
    getTreeList(id) {
      treeList({
        type: 2,
        hospitalId: this.hospitalId,
      }).then((res) => {
        if (res.code == 0) {
          this.caseMgrGroupList = res.data;
        }
      });
    },
    getPlatformListHandel() {
      // {disabled:false}
      getPlatformList({ disabled: false }).then((res) => {
        if (res.code == 0) {
          this.platformOptions = res.data;
        }
      });
    },
    submiAddCare1(ref) {
      this.$refs["addedParamData"].validate((valid) => {
        if (valid) {
          if (!this.addedParamData.avatarImageUrl)
            return this.$message.error("请上传团体头像");
          // if (!this.addedParamData.backgroundImageUrl) return this.$message.error('请上传团体背景图')
          // if (!this.addedParamData.messagePushImageUrl) return this.$message.error('请上传消息推送群');

          this.activeName1 += 1;
        }
      });
    },
    submiAddCare2() {
      if (this.doctorTeamMemberList.length == 0) {
        this.$message.info("请至少选择一位成员");
        return;
      }
      let Continue = false;
      for (let i = 0; i < this.doctorTeamMemberList.length; i++) {
        if (
          this.doctorTeamMemberList[i].doctorType == 1 &&
          this.doctorTeamMemberList[i].leader
        ) {
          Continue = true;
        }
        if (
          this.doctorTeamMemberList[i].doctorType == 2 &&
          this.doctorTeamMemberList[i].matron
        ) {
          Continue = true;
        }
      }
      if (!Continue) {
        this.$message.info("请设置领衔医生或者护士长");
        return;
      }
      this.activeName1 += 1;
    },
    closeaddCare2() {
      if (this.information1.doctorType != 4) {
        this.newSelectTteam = "";
        this.doctorTeam.type = "";
        this.isMdt = false;
        this.doctorTeam.id = "";
        this.doctorTeam.doctorTeamName = "";
        this.doctorTeam.name = "";
        this.doctorTeam.departmentId = "";
        this.doctorTeam.departmentName = "";
        this.doctorTeam.platformId = "";
        this.doctorTeam.platformName = "";
        this.doctorTeam.caseMgrGroupName = "";
      }
    },
    closeaddCare3() {
      // if(this.information1.doctortype !== 4){
      this.doctorCertificateSubmitDTO.idCard = {
        back: "",
        front: "",
        watermarkBack: "",
        watermarkFront: "",
      };
      (this.doctorCertificateSubmitDTO.other = {
        files: [],
        watermarkFiles: "",
      }),
        (this.doctorCertificateSubmitDTO.practice = {
          files: [],
          number: "",
          obtainDate: "",
          watermarkFiles: "",
        }),
        (this.doctorCertificateSubmitDTO.qualification = {
          files: [],
          obtainDate: "",
          number: "",
          watermarkFiles: "",
        });
      this.doctorCertificateSubmitDTO.title = {
        files: [],
        obtainDate: "",
        number: "",
        watermarkFiles: "",
      };
      this.doctorCertificateSubmitDTO.nameBadge = {
        files: [],
        fileList: [],
        obtainDate: "",
        number: "",
        watermarkFiles: "",
      };
    },
    getPlatformListInit() {
      getPlatformList({}).then((res) => {
        if (res.code == 0) {
          this.platformList.hospitalList = res.data;
        }
      });
    },
    closeaddCare1() {
      this.information1 = this.$options.data().information1;
      this.upavater = "";
      this.doctorTitleList = [];
    },
    redioChange() {
      this.information1.serviceScopeKm = "";
    },
    closeaddCare2() {
      // if(this.information1.doctorType != 4){
      this.newSelectTteam = "";
      this.doctorTeam.type = "";
      this.isMdt = false;
      this.doctorTeam.id = "";
      this.doctorTeam.doctorTeamName = "";
      this.doctorTeam.name = "";
      this.doctorTeam.departmentId = "";
      this.doctorTeam.departmentName = "";
      this.doctorTeam.platformId = "";
      this.doctorTeam.platformName = "";
      this.doctorTeam.caseMgrGroupName = "";
      // }
    },
    doctorTitleChange(v) {
      this.information1.titleName = "";
      for (var i = 0; i < this.doctorTitleList.length; i++) {
        if (this.doctorTitleList[i].id == v) {
          this.information1.titleName = this.doctorTitleList[i].name;
        }
      }
    },
    selectDoctorType(e) {
      this.getDoctorTitle(e);
      // if (e == 2) {
      this.information1.serviceScopeKm = "";
      (this.information1.note = ""), //介绍
        (this.information1.departmentId = ""); //科室ID
      this.information1.departmentName = ""; //科室ID
      this.information1.titleId = ""; //科室ID
      // this.information1.titleName = ""; //科室ID
      this.information1.professional = ""; //专业擅长
      this.information1.hospitalId = ""; //医院ID
      this.information1.hospitalName = "";
      this.information1.serviceScopeKm = ""; //上门服务km
      if (e == 2) {
        this.information1.provideNursingService = true;
      }
      // this.$refs['addForm'].clearValidate();
      this.closeaddCare2();
      this.closeaddCare3();
      // }
    },
    getDoctorTitle(t) {
      doctor_title(t).then((res) => {
        if (res.code == 0) {
          this.doctorTitleList = res.data;
        }
      });
    },
    handleMessageResponse1(response) {
      if (response.code == 0) {
        return (this.information.photoUrl =
          `${process.env.VUE_APP_OSS_URL}` + response.data);
      }
    },

    handleMessageResponse2(response) {
      if (response.code == 0) {
        return (this.upavater = `${process.env.VUE_APP_OSS_URL}${response.data}`);
      }
    },
    handleMessageResponse3(res) {
      if (res.code !== 0) {
        return;
      }
      this.doctorCertificateSubmitDTO.idCard.watermarkBack = `${process.env.VUE_APP_OSS_URL}${res.data.watermarkUrl}`;
      return (this.doctorCertificateSubmitDTO.idCard.back = `${process.env.VUE_APP_OSS_URL}${res.data.sourceUrl}`);
    },

    getdetail(data) {
      const machiningFiles = (filesName, type) => {
        if (type)
          return filesName
            .split(",")
            .map((sub) => `${process.env.VUE_APP_OSS_URL}` + sub);
        else return filesName.split(",").toString();
      };

      getDoctor(data ? data : this.$route.query.id).then((res) => {
        this.$nextTick(() => {
          // DOM 更新了
          // this.$refs["addForm"].clearValidate()

          if (res.data.hospitalId) this.hospitalChange(res.data.hospitalId);
          this.upavater = !!res.data.photoUrl
            ? process.env.VUE_APP_OSS_URL + res.data.photoUrl
            : "";
          this.hospitalObj = res.data.hospital;
          this.information1.mobile = res.data.phone;
          this.information1.realName = res.data.name; //姓名
          (this.information1.idCard = res.data.idCardNumber), //证件 号码
            (this.information1.id = res.data.id);
          // this.information1.photoUrlCopy = "";//用来展示图片
          (this.information1.note = res.data.introduction), //介绍
            (this.information1.departmentId = res.data.departmentId); //科室ID
          this.information1.departmentName = res.data.departmentName;
          this.information1.doctorType = res.data.doctorType; //医护类型1.医生,2.护士,3.医技,4.药师
          this.getDoctorTitle(res.data.doctorType);
          this.information1.hospitalId = res.data.hospitalId; //医院ID
          this.information1.hospitalName = res.data.hospitalName;
          this.information1.professional = res.data.professional; //专业擅长
          this.information1.titleId = res.data.titleId; //职称ID
          this.information1.titleName = res.data.titleName;
          this.information1.serviceScopeKm = res.data.serviceScopeKm; //上门服务km
          this.information1.provideNursingService =
            res.data.provideNursingService;
          // this.information1.disabled = res.data.disabled;
          // this.information1.idCardType = res.data.idCardType
          this.joinedTeamList = res.data.joinedTeamList
            ? res.data.joinedTeamList
            : [];
          if (res.data.certificateIdCard != null) {
            this.doctorCertificateSubmitDTO.idCard.back = `${process.env.VUE_APP_OSS_URL}${res.data.certificateIdCard.back}`;
            this.doctorCertificateSubmitDTO.idCard.watermarkBack = `${process.env.VUE_APP_OSS_URL}${res.data.certificateIdCard.watermarkBack}`;
            this.doctorCertificateSubmitDTO.idCard.front = `${process.env.VUE_APP_OSS_URL}${res.data.certificateIdCard.front}`;
            this.doctorCertificateSubmitDTO.idCard.watermarkFront = `${process.env.VUE_APP_OSS_URL}${res.data.certificateIdCard.watermarkFront}`;
          }
          //拷贝资格证信息
          if (
            res.data.certificateQualification != null &&
            res.data.certificateQualification.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.qualification.watermarkFiles =
              res.data.certificateQualification.watermarkFiles;
            this.doctorCertificateSubmitDTO.qualification.files =
              machiningFiles(res.data.certificateQualification.files, 1);
            this.doctorCertificateSubmitDTO.qualification.fileList =
              res.data.certificateQualification.fileList.map((item) => {
                return process.env.VUE_APP_OSS_URL + item;
              });
          }
          if (
            res.data.certificateQualification != null &&
            res.data.certificateQualification.number
          ) {
            this.doctorCertificateSubmitDTO.qualification.number =
              res.data.certificateQualification.number;
          }
          if (
            res.data.certificateQualification != null &&
            res.data.certificateQualification.getDate
          ) {
            this.doctorCertificateSubmitDTO.qualification.obtainDate =
              res.data.certificateQualification.getDate;
          }
          //拷贝执业证信息
          if (
            res.data.certificatePractice != null &&
            res.data.certificatePractice.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.practice.watermarkFiles =
              res.data.certificatePractice.watermarkFiles;
            this.doctorCertificateSubmitDTO.practice.files = machiningFiles(
              res.data.certificatePractice.files,
              1
            );
            this.doctorCertificateSubmitDTO.practice.fileList =
              res.data.certificatePractice.fileList.map((item) => {
                return process.env.VUE_APP_OSS_URL + item;
              });
          }
          if (
            res.data.certificatePractice != null &&
            res.data.certificatePractice.number
          ) {
            this.doctorCertificateSubmitDTO.practice.number =
              res.data.certificatePractice.number;
          }
          if (
            res.data.certificatePractice != null &&
            res.data.certificatePractice.getDate
          ) {
            this.doctorCertificateSubmitDTO.practice.obtainDate =
              res.data.certificatePractice.getDate;
          }
          //拷贝职业证信息
          if (
            res.data.certificateTitle != null &&
            res.data.certificateTitle.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.title.watermarkFiles =
              res.data.certificateTitle.watermarkFiles;
            this.doctorCertificateSubmitDTO.title.files = machiningFiles(
              res.data.certificateTitle.files,
              1
            );
            this.doctorCertificateSubmitDTO.title.fileList =
              res.data.certificateTitle.fileList.map((item) => {
                return process.env.VUE_APP_OSS_URL + item;
              });
          }
          //拷贝胸牌
          if (
            res.data.certificateNameBadge != null &&
            res.data.certificateNameBadge.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.nameBadge.watermarkFiles =
              res.data.certificateNameBadge.watermarkFiles;
            this.doctorCertificateSubmitDTO.nameBadge.files = machiningFiles(
              res.data.certificateNameBadge.files,
              1
            );
            this.doctorCertificateSubmitDTO.nameBadge.fileList =
              res.data.certificateNameBadge.fileList.map((item) => {
                return process.env.VUE_APP_OSS_URL + item;
              });
          }

          //拷贝其他相关
          if (
            res.data.certificateOther != null &&
            res.data.certificateOther.fileList.length > 0
          ) {
            this.doctorCertificateSubmitDTO.other.watermarkFiles =
              res.data.certificateOther.watermarkFiles;
            this.doctorCertificateSubmitDTO.other.files = machiningFiles(
              res.data.certificateOther.files,
              1
            );
            this.doctorCertificateSubmitDTO.other.fileList =
              res.data.certificateOther.fileList.map((item) => {
                return process.env.VUE_APP_OSS_URL + item;
              });
          }

          // if (res.code == 0) {
          //   this.getListByDoctorIdInit();
          //   //有实体平台的时候，需要根据hospitalId进行查询下级实体科室列表
          // }
        });
      });
    },
    /**
     * @description: 选择线下机构下的个案
     * @param {*} event
     * @return {*}
     */

    addHospitalChange(event = {}) {
      this.addedParamData.openDepartmentId = "";
      this.addedParamData.messagePushImageUrl = "";
      this.addedParamData.caseMgrGroupId = "";
      this.addedParamData.caseMgrGroup = {};
      this.treeListHos = [];
      // this.selectOnCallBack(event)
      this.openDepartmentList = [];
      this.addedParamData.hospitalId = event.id || this.$store.state.hospitalId;
      this.addedParamData.hospitalName =
        event.name || this.$store.state.orgName;
      this.addedParamData.platformId =
        event.platformId || this.$store.state.platformId;
      this.$set(
        this.addedParamData,
        "companyId",
        event.companyId || this.$store.state.companyId
      );
      getHospitalDepartmentList({
        hospitalId: event.id || this.$store.state.hospitalId,
      }).then((res) => {
        if (res.code == 0) {
          this.openDepartmentList = res.data;
        }
      });
      this.getTreeListHos(event.id || this.$store.state.hospitalId);
    },
    getTreeListHos() {
      treeList({
        hospitalId:
          this.addedParamData.hospitalId || this.$store.state.hospitalId,
        // 平台id
        companyId: this.$store.state.companyId,
        platformId:
          this.addedParamData.platformId || this.$store.state.platformId,
        type: 2,
      }).then((res) => {
        if (res.code == 0) {
          this.treeListHos = res.data;
        }
      });
    },
    /**
     * @description: 获取相应医院下的科室
     * @param {*} event
     * @param {*} type
     * @return {*}
     */
    selectOnCallBack(event, type) {
      openeDpartment({
        hospitalId: event,
      }).then((res) => {
        if (res.code == 0) {
          if (type == "selectOnChangeOne") {
            this.departmentListOne = res.data;
          } else {
            this.departmentList = res.data;
          }
        }
      });
    },
    /**
     * @description: 线下机构列表
     */
    getHospitalListHandel() {
      plateFormOn().then((res) => {
        if (res.code == 0) {
          this.hospitalOptions = res.data;
        }
      });
    },
    /**
     * @description: 根据医生ID查询平台列表
     * @param {*}
     * @return {*}
     */
    // getListByDoctorIdInit() {
    //   getListByDoctorId(this.information1.id).then(res => {
    //     if (res.code == 0) {
    //       this.platformList.tableData = res.data;
    //     }
    //   });
    // }
    hospitalNameFun(arr, tag) {
      let hospitalName = null;
      let departmentName = null;
      let hospitalNameList = [];
      let departmentNameList = [];
      arr.forEach((item, index) => {
        hospitalNameList.push(item.hospitalName);
        if (item.openDepartmentIdList && item.openDepartmentIdList.length > 0) {
          item.openDepartmentIdList.forEach((el, i) => {
            departmentNameList.push(el.openDepartmentName);
          });
        }
      });
      if (tag == 1) {
        hospitalName = hospitalNameList.toString();
        return hospitalName;
      } else {
        departmentName = departmentNameList.toString();
        return departmentName;
      }
    },
    getDiseaseType() {
      let params = {
        hospitalId: this.hospitalNewId,
        openDepartmentId: this.openDepartmentIdNew,
        teamId: this.teamIdNew,
        configType: "team",
      };
      findDiseaseTypeByother(params).then((res) => {
        if (res.code == 0) {
          if (res.data && res.data.length > 0) {
            this.diseaseTypeList = res.data;
          } else {
            this.diseaseTypeList = [];
          }
        }
      });
    },
    editFlagStatusClick(item) {
      this.editFlagStatus = item.flag;
      this.newId = item.newId;
    },
    saveChildClick() {
      console.log("ass");
      this.saveClick("paramData");
    },
    saveClick(paramData) {
      console.log(this.editFlagStatus, "this.editFlagStatus");
      this.$refs[paramData].validate((valid) => {
        if (valid) {
          // this.form.focusFieldConfigDetailList = this.dataList;
          if (this.editFlagStatus) {
            updateConfig({
              ...this.paramData,
              hospitalId: this.hospitalNewId,
              teamId: this.teamIdNew,
              configType: "team",
              openDepartmentId: this.openDepartmentIdNew,
              id: this.newId,
            })
              .then((res) => {
                this.$message.success("编辑成功");
                // this.paramData.diseaseId = null;
                this.bigStatus = false;
                this.$refs.child.commonQueryRequest();
                this.focusFieldConfig();
                //
                // this.$refs.paramData.resetFields();
              })
              .catch((res) => {
                // this.bigStatus = false;
                // this.$refs.child.commonQueryRequest();
                // this.paramData.diseaseId = null;
                // this.$refs.paramData.resetFields();
              });
          } else {
            saveConfig({
              ...this.paramData,
              hospitalId: this.hospitalNewId,
              teamId: this.teamIdNew,
              configType: "team",
              openDepartmentId: this.openDepartmentIdNew,
            })
              .then((res) => {
                this.$message.success("新增成功");
                // this.paramData.diseaseId = null;
                this.bigStatus = false;
                this.$refs.child.commonQueryRequest();
                this.focusFieldConfig();
                // this.$refs.paramData.resetFields();
              })
              .catch((res) => {
                // this.bigStatus = false;
                // this.$refs.child.commonQueryRequest();
                // this.paramData.diseaseId = null;
                // this.$refs.paramData.resetFields();
              });
          }
        } else {
          return false;
        }
      });
    },
    // 获取规则弹框传递的列表数据
    focusFieldRuleDTOData(list) {
      console.log("规则list", list);
    },
    // 点击已配置病种-查看对应病种配置字段
    tagDetail(item) {
      this.paramData.diseaseId = item.diseaseId;
      this.diseaseId = item.diseaseId;
      this.diseaseActive = item.label;
      this.bigStatus = false;
    },
    // 查看全部已配置病种
    detailAllDisease() {
      this.foldIndex = this.tagDiseaseList.length;
    },
    // 收起
    retractClick() {
      let boxWidth = document.querySelector(".tabs-box").offsetWidth;
      let arr = document.querySelectorAll(".sub-tabs-list");
      let btnWidth = this.$refs.fold.offsetWidth;
      this.variable(boxWidth, arr, btnWidth)
        .then((res) => {
          this.foldIndex = res - 1;
        })
        .catch((error) => {
          // 此处不足一行时我将按钮隐藏了
          // this.$refs.fold.style.display = error
        });
    },
    // 点击新增病种配置按钮展示新增病种选择框
    addDiseaseConfig() {
      this.addDiseaseVisible = true;
    },
    // 确定选择病种
    addDiseaseSure() {
      // 筛选找到名字
      this.diseaseId = this.paramData.diseaseId;
      let name = "";
      this.diseaseTypeList.forEach((item) => {
        if (item.id === this.paramData.diseaseId) {
          name = item.suborderName;
        }
      });
      // 判断是否存在
      let flag = false;
      this.tagDiseaseList.forEach((item) => {
        if (item.label === name) {
          flag = true;
        }
      });
      if (flag) {
        this.$message("此病种已配置完成");
      } else {
        this.tagDiseaseList.unshift({
          label: name,
          diseaseId: this.diseaseId,
          id: this.paramData.diseaseId,
        });
        this.diseaseActive = name;
        this.addDiseaseVisible = false;
        this.bigStatus = true;
      }
    },
    confimClick(list) {
      console.log(list, "list");
      this.paramData.focusFieldConfigDetailList = list;
    },
    hospitalChangeNew() {
      // this.paramData.diseaseId
      // this.commonQueryRequest();
    },

    editClick() {
      this.bigStatus = true;
      this.addDiseaseVisible = false;
    },
    // 封装可折叠标签组件
    variable(boxWidth, arr, btnWidth) {
      // boxWidth  -- 盒子宽度          arr  -- 要处理的dom列表     btnWidth  -- 展开/折叠按钮的宽度
      return new Promise((resolve, reject) => {
        let array = Array.from(arr); //
        // 求出元素叠加后的总长度
        // 使用reduce方法计算总和
        let sum = array.reduce((acc, obj) => {
          return acc + obj.offsetWidth;
        }, 0);
        console.log("sum", sum);
        console.log("boxWidth", boxWidth);
        if (sum > boxWidth) {
          // 元素总长度大于盒子宽度
          let total = 0;
          let index = 0;
          for (let i = 0; i < array.length; i++) {
            total += array[i].offsetWidth;
            if (total >= boxWidth - btnWidth) {
              index = i;
              break;
            }
          }
          // 返回应该展示的标签数量
          resolve(parseInt(index));
        } else {
          // 元素总长度小于盒子宽度
          console.log("小");
          reject("none");
        }
      });
    },
  },

  beforeDestroy() {
    local.remove("doctorChainId");
  },
  created() {
    this.VUE_APP_BASE_URL = "/api/dsicm-contact-platform/feign/file/upload";
    this.VUE_APP_BASE_URL1 =
      "/api/dsicm-contact-platform/feign/file/uploadWatermark";
    this.VUE_APP_WECHATBASE_URL =
      "/api/dsicm-contact-platform/feign/file/wechat/upload";

    // this.getDoctorTitle(); //获取职称段位
    // this.getPlatformListInit()
    this.detailsHandel();
    // this.getTreeListHos()
    this.getPlatformListHandel();
    if (this.$store.state.userPlatForm === "platForm") {
      // 平台--线下机构接口列表
      this.getHospitalListHandel();
    } else {
      this.addHospitalChange(); // 首次进入获取团队科室列表
    }
    this.$nextTick(() => {
      if (this.$route.query.type) {
        this.handleTabClick(this.$route.query.type);
      }
    });
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.box {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.upload-vedio-wrapper {
  display: flex;
}
.vedio-upload-btn {
  // padding-top: 100px;
  // padding-left: 20px;
  display: flex;
  align-items: flex-end;
}
.vedio {
  // width: fit-content;
  position: relative;
  padding: 20px;
  border-radius: 15px;
  background: #f5f5f5;
  margin-right: 20px;

  // width: 260px;
  // height: 120px;
  .del-vedio-btn {
    font-size: 32px;
    font-weight: 700;
    position: absolute;
    top: -7px;
    right: -5px;
  }
  span {
    position: absolute;
    top: -7px;
    right: -5px;
    width: 16px;
    height: 16px;
    color: #ffffff;
    background: #999999;
    border-radius: 50%;
    text-align: center;
    cursor: pointer;
    line-height: 1.4;
  }
}

.team-video-intro {
  display: inline-block;
  margin-left: 20px;
  font-size: 12px;
  color: #999999;
}
.avatar-uploader {
  display: inline-block;
}

/deep/.el-select {
  width: 100%;
}
/deep/.el-cascader {
  width: 100%;
}
/deep/.el-tabs__nav-wrap::after {
  background-color: #fff;
}
.header {
  background: #fff;
  .text {
    padding: 24px;
    color: #333333;
    font-size: 14px;
    line-height: 22px;
    padding-bottom: 20px;
    // border-bottom: 16px solid #F8F8F8;
    span:nth-child(2) {
      color: #333;
    }

    span:nth-child(1) {
      color: #999;
    }
  }
  .top-tabs {
    // display: flex;
    // width: 600px;
    padding-left: 24px;
    // padding-top: 40px;

    div {
      cursor: pointer;
      vertical-align: top;
      display: inline-block;
      line-height: 26px;
      &:hover{
        color: #1a7bfc;
      }
    }

    .tabs-cliked {
      color: #1a7bfc;

      span {
        padding-bottom: 4px;
        border-bottom: 2px solid #1a7bfc;
      }
    }
    div:nth-of-type(2) {
      margin-left: 64px;
    }
    div:nth-of-type(3) {
      margin-left: 64px;
    }
    div:nth-of-type(4) {
      margin-left: 64px;
    }
    div:last-of-type {
      min-width: 275px;
      margin-left: 64px;
    }
  }
}
.content {
  margin: 15px;
  padding: 10px 20px;
  background: #fff;
  .team-item {
    margin-left: 40px;
    margin-bottom: 20px;
    h3 {
      margin-bottom: 30px;
      font-size: 14px;
    }

    ul {
      display: flex;
      width: 100%;

      li {
        flex: 1;
        font-size: 12px;
        display: flex;
        label {
          white-space: nowrap;
          margin-right: 20px;
        }
      }
    }
  }

  .tip-zhengshu {
    color: #999999;
  }

  .label-circle {
    display: flex;
    margin-bottom: 10px;
    height: 25px;
    align-items: center;
    width: 128px;
    flex-flow: row-reverse;

    span:nth-of-type(2) {
      margin-right: 10px;
      width: 6px;
      height: 6px;
      background: #d0e4ff;
      border-radius: 50%;
    }
  }

  .line-div {
    margin: 0px 0 20px;
    display: flex;
    align-items: center;
    span:nth-of-type(1) {
      display: inline-block;
      width: 4px;
      height: 14px;
      background: #1a7bfc;
      margin-right: 10px;
      vertical-align: middle;
    }

    span:nth-of-type(2) {
      font-weight: bold;
      font-size: 14px;
      line-height: 14px;
      vertical-align: middle;
      flex: 1;
    }
    .add-serve-btn {
      height: 36px;
    }
  }
  .dialog-footer {
    padding: 20px;
    display: block;
  }
  .dialog-footer {
    display: block;
    margin-top: 10px;
    padding: 5px 0 10px;
    text-align: center;
    .dialog-btn {
      width: 110px;
      height: 32px;
    }
  }
}
.no-div {
  margin: 125px auto 20px;
  text-align: center;
  p {
    margin-top: 20px;
  }
}
.list-two {
  margin-bottom: 12px;
}
.pagenation {
  display: flex;
  justify-content: flex-end;
}
/deep/.el-form-item .el-form-item {
  margin-bottom: 20px !important;
}
.btn-box {
  text-align: center;
}

.no-disease {
  font-size: 12px;
  color: #666666;
  line-height: 40px;
}
.searchTag {
  display: inline-block;
  height: 28px;
  border-radius: 18px;
  border: 1px solid #a7cdff;
  margin-right: 15px;
  padding: 0px 15px;
  color: #1a7bfc;
  cursor: pointer;
  line-height: 28px;
  &.active {
    background: #1a7bfc;
    color: #ffffff;
  }
}
/deep/.diease-btn-select {
  .el-button {
    height: 32px;
    margin-top: 4px;
  }
  .el-form-item {
    .el-form-item__content {
      display: flex;
    }
  }
}

.all-detail-icon {
  display: inline-block;
  font-size: 12px;
  font-weight: 550;
  color: #1a7bfc;
  line-height: 18px;
  cursor: pointer;
  i {
    font-weight: bold;
    margin-left: 6px;
  }
}
</style>